/* 
 * DriverView Component - Complete Driver Dashboard
 * Features:
 * - Driver profile with image and basic info
 * - Statistics cards (jobs, convoy, rating)
 * - Document viewer with modal
 * - Performance metrics
 * - Live location map
 * - Activity timeline
 * - Charts for income and time analysis
 */
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Select,
//   MenuItem,
// } from "@mui/material";
// import { useLocation,useNavigate } from 'react-router-dom';

// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });
// const Item = styled(Paper)(({ theme }) => ({
//   backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: "center",
//   color: theme.palette.black,
// }));

// const Search = styled("div")(({ theme }) => ({
//   position: "relative",
//   borderRadius: theme.shape.borderRadius,
//   backgroundColor: alpha(theme.palette.common.black, 0.1),
//   "&:hover": {
//     backgroundColor: alpha(theme.palette.common.black, 0.15),
//   },
//   marginLeft: 0,
//   width: "100%",
//   [theme.breakpoints.up("sm")]: {
//     marginLeft: theme.spacing(1),
//     width: "auto",
//   },
// }));

// const SearchIconWrapper = styled("div")(({ theme }) => ({
//   padding: theme.spacing(0, 2),
//   height: "100%",
//   position: "absolute",
//   pointerEvents: "none",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
// }));

// const StyledInputBase = styled(InputBase)(({ theme }) => ({
//   color: "black",
//   width: "100%",
//   "& .MuiInputBase-input": {
//     padding: theme.spacing(1, 1, 1, 0),
//     // vertical padding + font size from searchIcon
//     paddingLeft: `calc(1em + ${theme.spacing(4)})`,
//     transition: theme.transitions.create("width"),
//     [theme.breakpoints.up("sm")]: {
//       width: "12ch",
//       "&:focus": {
//         width: "20ch",
//       },
//     },
//   },
// }));

// const chartSetting = {
//   // xAxis: [
//   //     {
//   //         label: 'rainfall (mm)',
//   //     },
//   // ],
//   // width: 500,
//   // height: 400,
//   yAxis: [
//     {
//       label: "rainfall (mm)",
//     },
//   ],
//   // maxwidth: 500,
//   // height: 200,
//   sx: {
//     [`.${axisClasses.left} .${axisClasses.label}`]: {
//       transform: "translate(-20px, 0)",
//     },
//   },
// };

// const dataset = [
//   {
//     jobs: 59,
//     details: "Jobs",
//   },
//   {
//     dhaba: 52,
//     details: "Dhaba",
//   },
//   {
//     mech: 76,
//     details: "Mech",
//   },
//   {
//     convey: 25,
//     details: "Convey",
//   },
//   {
//     profile: 25,
//     details: "Profile",
//   },
//   {
//     others: 45,
//     details: "Others",
//   },
// ];

// const valueFormatter = (value) => `${value}mm`;

// export default function DriverView() {
//     const location = useLocation();
//     const navigate = useNavigate();
//   let driverData = location.state?.data;
//   if (driverData && driverData.data) driverData = driverData.data;

//   React.useEffect(() => {
//     if (!driverData) {
//       alert("No driver data found");
//       navigate("/Users/Drivers", { replace: true });
//     }
//     console.log("Driver data in DriverView:", driverData);
//   }, [driverData, navigate]);
//   if(!driverData) return null;
//   const [open, setOpen] = React.useState(false);
// const safe = (val, fallback = "N/A") => (val !== null && val !== undefined && val !== "" ? val : fallback);
//   const handleClickOpen = () => {
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//   };
//   const handleFileButtonClick = () => {
//     // Trigger click event on the file input element
//     document.getElementById("fileInput").click();
//   };

//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const toggleModal = () => {
//     setIsModalOpen(!isModalOpen);
//   };
//   const [week, setWeek] = React.useState("");

//   const handleChange = (event) => {
//     setWeek(event.target.value);
//   };
//   return (
//     <>
//      {/*
//       <div>
//       <React.Fragment>
//         <Stack direction="row" spacing={2}>
//           <Typography
//             variant="text"
//             onClick={handleClickOpen}
//             sx={{ color: "Black" }}
//           >
//             View
//           </Typography>
//         </Stack>
//         <Dialog
//           fullScreen
//           open={open}
//           onClose={handleClose}
//           TransitionComponent={Transition}
//           PaperProps={{
//             style: {
//               backgroundColor: "white",
//             },
//           }}
//         >
//           {/* <AppBar sx={{ position: 'relative', height: '30px' }}>
//                         <Toolbar>
//                             <IconButton
//                                 edge="start"
//                                 color="inherit"
//                                 onClick={handleClose}
//                                 aria-label="close"
//                             >
//                                 <CloseIcon />
//                             </IconButton> */}
//           {/* <Typography sx={{ ml: 2, flex: 1 }} component="div">
//                                 Driver Detail
//                             </Typography> */}
//           {/*
//                         </Toolbar>

//                     </AppBar>
//           <Box display="flex" flexDirection="column">
//             <Box sx={{ flexGrow: 1 }}>
//               {/* <Grid container spacing={1}>
//               {/* first column
//               <Grid item xs={12}>
//                 <Item
//                   style={{
//                     backgroundColor: "#fff",
//                     height: "40px",
//                     paddingInline: "3px",
//                   }}
//                 >
//                   <Typography style={{ color: "black", textAlign: "left" }}>
//                     <IconButton
//                       edge="start"
//                       onClick={handleClose}
//                       aria-label="close"
//                       style={{ marginLeft: "4px" }}
//                     >
//                       <CloseIcon
//                         style={{
//                           backgroundColor: "red",
//                           color: "white",
//                           borderRadius: "50%",
//                           fontSize: "20px",
//                         }}
//                       />
//                     </IconButton>
//                     <b>ID: {safe(driverData.user_id)}</b>
//                     <Typography className="btn">
//                       <Button
//                         variant="contained"
//                         sx={{
//                           backgroundColor: "green",
//                           "&:hover": { backgroundColor: "orange" },
//                           textAlign: "right",
//                         }}
//                       >
//                         Edit
//                       </Button>
//                       &nbsp;&nbsp;
//                       <Button
//                         variant="contained"
//                         sx={{
//                           backgroundColor: "blue",
//                           "&:hover": { backgroundColor: "orange" },
//                           textAlign: "right",
//                           marginLeft: "10px",
//                         }}
//                       >
//                         <AddIcon />
//                         Add Ticket
//                       </Button>
//                       &nbsp;&nbsp;
//                     </Typography>
//                   </Typography>
//                 </Item>
//               </Grid>
//               <div style={{ marginBottom: "5px" }}></div>
//               <Grid item xs={12} md={4}>
//                 <Grid container spacing={1}>
//                   <Grid item xs={12} md={2} style={{ color: "black" }}>
//                     <Grid>
//                       <Item style={{ backgroundColor: "#fff" }}>
//                         <Stack direction="row">
//                           {/* <img src='.src/scenes/mainfavicon.png' alt='Drivers profile'/>
//                           <AccountCircleIcon
//                             style={{ color: "grey", fontSize: "100px" }}
//                           />
//                           <br></br>
//                           <Typography style={{ color: "black" }}>
//                             Driver<br></br>
//                             <Chip
//                               label={
//                                 <span
//                                   style={{
//                                     color: "red",
//                                     fontSize: "12px",
//                                     backgroundColor: "pink",
//                                     borderRadius: "5px",
//                                   }}
//                                 >
//                                   Standard
//                                 </span>
//                               }
//                             />
//                           </Typography>
//                         </Stack>
//                         <br></br>
//                         <Stack direction="row">
//                           <Stack direction="row">
//                             <StarIcon
//                               style={{ color: "green", fontSize: "30px" }}
//                             />
//                             <br></br>
//                             <Typography
//                               style={{
//                                 color: "black",
//                                 fontSize: "20px",
//                                 width: "auto",
//                               }}
//                             >
//                               5.0<br></br>
//                               <Chip
//                                 label={
//                                   <span
//                                     style={{ color: "black", fontSize: "15px" }}
//                                   >
//                                     Rating
//                                   </span>
//                                 }
//                               />
//                             </Typography>
//                           </Stack>
//                         </Stack>
//                         <br></br>
//                         <Typography
//                           style={{
//                             color: "black",
//                             fontSize: "20px",
//                             textAlign: "left",
//                           }}
//                         >
//                           Details
//                         </Typography>
//                         <hr></hr>
//                         <Typography
//                           style={{ color: "#c2c2d6", textAlign: "left" }}
//                         >
//                           Name:{safe(driverData.username)}<br></br>
//                           Contact:{safe(driverData.phone)}<br></br>
//                           Email:{safe(driverData.email)} <br></br>
//                           State: {safe(driverData.state)}<br></br>
//                           Address:{safe(driverData.address)}<br></br>
//                           Pincode: {safe(driverData.pincode)}
//                         </Typography>
//                         <br></br>
//                         <Typography
//                           style={{
//                             color: "black",
//                             textAlign: "left",
//                             fontSize: "20px",
//                           }}
//                         >
//                           Documents
//                         </Typography>
//                         <hr></hr>
//                         <div style={{ marginBottom: "10px" }}></div>
//                         <Stack direction="row" style={{ padding: "5px" }}>
//                           <Button
//                             variant="outlined"
//                             style={{
//                               color: "green",
//                               fontSize: "8px",
//                               borderRadius: "10px",
//                             }}
//                           >
//                             Aadhar Card Front
//                           </Button>
//                           &nbsp;
//                           <Button
//                             variant="outlined"
//                             style={{
//                               color: "orange",
//                               fontSize: "8px",
//                               borderRadius: "10px",
//                             }}
//                           >
//                             Aadhar Card Back
//                           </Button>
//                           &nbsp;
//                           {/* <Chip label={<span style={{ color: "green", fontSize: "10px" }}>Aadhar Card Front</span>} variant="outlined" />&nbsp;
//                                                     <Chip label={<span style={{ color: "orange", fontSize: "10px" }}>Aadhar Card Back</span>} variant="outlined" />
//                         </Stack>

//                         <Stack direction="row" style={{ padding: "5px" }}>
//                           <Button
//                             variant="outlined"
//                             style={{
//                               color: "blue",
//                               fontSize: "8px",
//                               borderRadius: "10px",
//                             }}
//                           >
//                             Driving License Front
//                           </Button>
//                           &nbsp;
//                           <Button
//                             variant="outlined"
//                             style={{
//                               color: "grey",
//                               fontSize: "8px",
//                               borderRadius: "10px",
//                             }}
//                           >
//                             Character
//                           </Button>
//                           &nbsp;
//                           {/* <Chip label={<span style={{ color: "blue", fontSize: "10px" }}>Driving License Front</span>} variant="outlined" />&nbsp;
//                                                     <Chip label={<span style={{ color: "grey", fontSize: "10px" }}>Character</span>} variant="outlined" />
//                         </Stack>

//                         <Stack
//                           direction="row"
//                           style={{ padding: "5px", paddingBottom: "60px" }}
//                         >
//                           <Button
//                             variant="outlined"
//                             style={{
//                               color: "red",
//                               fontSize: "8px",
//                               borderRadius: "10px",
//                             }}
//                           >
//                             Driving License Back
//                           </Button>
//                           &nbsp;
//                           <Button
//                             variant="outlined"
//                             style={{
//                               color: "purple",
//                               fontSize: "8px",
//                               borderRadius: "10px",
//                             }}
//                           >
//                             Insurance
//                           </Button>
//                           &nbsp;
//                           {/* <Chip label={<span style={{ color: "red", fontSize: "10px" }}>Driving License Back</span>} variant="outlined" />&nbsp;
//                                                     <Chip label={<span style={{ color: "purple", fontSize: "10px" }}>Insurance</span>} variant="outlined" />
//                         </Stack>

//                         <Stack direction="row" style={{ padding: "5px" }}>
//                           <Button
//                             variant="contained"
//                             style={{ backgroundColor: "green" }}
//                           >
//                             Edit
//                           </Button>
//                           &nbsp;&nbsp;
//                           <Button variant="outlined" style={{ color: "red" }}>
//                             Suspend
//                           </Button>
//                         </Stack>
//                       </Item>
//                     </Grid>
//                   </Grid>
//                   {/* second column
//                   <Grid item xs={12} md={7} style={{ color: "black" }}>
//                     <Grid container spacing={1} style={{ marginBottom: "5px" }}>
//                       <Grid item xs={12} sm={6} md={6} lg={6}>
//                         {/* first row

//                         <Grid container spacing={1}>
//                           <Grid item xs={12} sm={6}>
//                             <Item style={{ backgroundColor: "#fff" }}>
//                               <Typography
//                                 gutterBottom
//                                 variant="subtitle1"
//                                 style={{
//                                   textAlign: "left",
//                                   fontSize: "20px",
//                                   color: "#4d4f5c",
//                                 }}
//                               >
//                                 Jobs Applied
//                               </Typography>
//                               <Typography
//                                 variant="body2"
//                                 gutterBottom
//                                 style={{ textAlign: "right", color: "#4d4f5c" }}
//                               >
//                                 <LocalShippingIcon
//                                   style={{
//                                     color: "white",
//                                     borderRadius: "50%",
//                                     backgroundColor: "red",
//                                     paddingInline: "3px",
//                                   }}
//                                 />
//                               </Typography>
//                               <Typography
//                                 variant="body2"
//                                 style={{ textAlign: "left", fontSize: "16px" }}
//                                 color="blue"
//                               >
//                                 275
//                               </Typography>
//                             </Item>
//                           </Grid>

//                           <Grid item xs={12} sm={6}>
//                             <Item style={{ backgroundColor: "#fff" }}>
//                               <Typography
//                                 gutterBottom
//                                 variant="subtitle1"
//                                 style={{
//                                   textAlign: "left",
//                                   fontSize: "20px",
//                                   color: "#4d4f5c",
//                                 }}
//                               >
//                                 Jobs rejected
//                               </Typography>
//                               <Typography
//                                 variant="body2"
//                                 gutterBottom
//                                 style={{ textAlign: "right", color: "#4d4f5c" }}
//                               >
//                                 <SwipeLeftIcon
//                                   style={{
//                                     color: "white",
//                                     borderRadius: "50%",
//                                     backgroundColor: "purple",
//                                     paddingInline: "3px",
//                                   }}
//                                 />
//                               </Typography>
//                               <Typography
//                                 variant="body2"
//                                 style={{ textAlign: "left", fontSize: "16px" }}
//                                 color="blue"
//                               >
//                                 275
//                               </Typography>
//                             </Item>
//                           </Grid>
//                         </Grid>
//                       </Grid>

//                       <Grid item xs={12} sm={6} md={6} lg={6}>
//                         {/* first row
//                         <Grid container spacing={1}>
//                           <Grid item xs={12} sm={6}>
//                             <Item style={{ backgroundColor: "#fff" }}>
//                               <Typography
//                                 gutterBottom
//                                 variant="subtitle1"
//                                 style={{
//                                   textAlign: "left",
//                                   fontSize: "20px",
//                                   color: "#4d4f5c",
//                                 }}
//                               >
//                                 Jobs accepted
//                               </Typography>
//                               <Typography
//                                 variant="body2"
//                                 gutterBottom
//                                 style={{ textAlign: "right", color: "#4d4f5c" }}
//                               >
//                                 <CheckCircleIcon
//                                   style={{
//                                     color: "white",
//                                     borderRadius: "50%",
//                                     backgroundColor: "green",
//                                     paddingInline: "3px",
//                                   }}
//                                 />
//                               </Typography>
//                               <Typography
//                                 variant="body2"
//                                 style={{ textAlign: "left", fontSize: "16px" }}
//                                 color="blue"
//                               >
//                                 275
//                               </Typography>
//                             </Item>
//                           </Grid>

//                           <Grid item xs={12} sm={6}>
//                             <Item style={{ backgroundColor: "#fff" }}>
//                               <Typography
//                                 gutterBottom
//                                 variant="subtitle1"
//                                 style={{
//                                   textAlign: "left",
//                                   fontSize: "20px",
//                                   color: "#4d4f5c",
//                                 }}
//                               >
//                                 Convoy created
//                               </Typography>
//                               <Typography
//                                 variant="body2"
//                                 gutterBottom
//                                 style={{ textAlign: "right", color: "#4d4f5c" }}
//                               >
//                                 <HourglassBottomIcon
//                                   style={{
//                                     color: "white",
//                                     borderRadius: "50%",
//                                     backgroundColor: "blue",
//                                     paddingInline: "3px",
//                                   }}
//                                 />
//                               </Typography>
//                               <Typography
//                                 variant="body2"
//                                 style={{ textAlign: "left", fontSize: "16px" }}
//                                 color="blue"
//                               >
//                                 275
//                               </Typography>
//                             </Item>
//                           </Grid>
//                         </Grid>
//                       </Grid>
//                     </Grid>

//                     <Grid container spacing={1}>
//                       <Grid item xs={12} md={6} style={{ color: "black" }}>
//                         <Grid container spacing={1}>
//                           <Grid item xs={12}>
//                             <Grid>
//                               <Item style={{ backgroundColor: "#fff" }}>
//                                 <Stack direction="row">
//                                   <Stack direction="row">
//                                     <Inventory2Icon
//                                       style={{
//                                         color: "grey",
//                                         fontSize: "40px",
//                                         marginTop: "15px",
//                                       }}
//                                     />
//                                     <Typography
//                                       style={{
//                                         color: "black",
//                                         fontSize: "15px",
//                                         width: "auto",
//                                         marginTop: "15px",
//                                       }}
//                                     >
//                                       Rs. 1450.50<br></br>
//                                       <Chip
//                                         label={
//                                           <span
//                                             style={{
//                                               color: "black",
//                                               fontSize: "12px",
//                                               borderRadius: "10px",
//                                             }}
//                                           >
//                                             Total amount
//                                           </span>
//                                         }
//                                       />
//                                     </Typography>
//                                   </Stack>
//                                   <Stack
//                                     sx={{ marginLeft: "200px", color: "black" }}
//                                   >
//                                     <FormControl
//                                       sx={{ m: 1, minWidth: 30 }}
//                                       size="small"
//                                       style={{ color: "black" }}
//                                     >
//                                       {/* <InputLabel id="demo-simple-select-helper-label">Week</InputLabel>
//                                       <Select
//                                         // labelId="demo-simple-select-helper-label"
//                                         // id="demo-select-small"
//                                         value={week}
//                                         onChange={handleChange}
//                                         sx={{
//                                           color: "black",
//                                           "& .MuiSelect-icon": {
//                                             color: "black",
//                                           },
//                                           backgroundColor: "#CCD3CA",
//                                         }}
//                                         displayEmpty
//                                         inputProps={{
//                                           "aria-label": "Without label",
//                                         }}
//                                       >
//                                         <MenuItem value={10}>Day</MenuItem>
//                                         <MenuItem value={20}>Week</MenuItem>
//                                         <MenuItem value={30}>Month</MenuItem>
//                                         <MenuItem value={30}>Year</MenuItem>
//                                       </Select>
//                                     </FormControl>
//                                     <Chip
//                                       label={
//                                         <span
//                                           style={{
//                                             color: "green",
//                                             fontSize: "12px",
//                                             backgroundColor: "#C1F2B0",
//                                           }}
//                                         >
//                                           3.2%
//                                           <NorthEastIcon />
//                                         </span>
//                                       }
//                                     />
//                                   </Stack>
//                                 </Stack>
//                                 <LineChart
//                                   sx={{
//                                     "& .MuiAreaElement-series-data": {
//                                       fill: "url('#myGradient')",
//                                     },
//                                   }}
//                                   xAxis={[{ data: [1, 2, 3, 5, 8, 10] }]}
//                                   series={[
//                                     {
//                                       id: "data",
//                                       curve: "linear",
//                                       data: [2.9, 5.5, 5, 4.6, 6.2, 5.8],
//                                       area: true,
//                                     },
//                                   ]}
//                                   maxwidth={300}
//                                   height={250}
//                                 >
//                                   <defs>
//                                     <linearGradient
//                                       id="myGradient"
//                                       gradientTransform="rotate(90)"
//                                     >
//                                       <stop offset="5%" stopColor="#8576FF" />
//                                       <stop offset="95%" stopColor="#fff" />
//                                     </linearGradient>
//                                   </defs>
//                                 </LineChart>
//                               </Item>
//                             </Grid>
//                           </Grid>
//                           <div style={{ paddingBottom: "5px" }}></div>
//                           <Grid item xs={12}>
//                             <Grid>
//                               <Item style={{ backgroundColor: "#fff" }}>
//                                 <BarChart
//                                   dataset={dataset}
//                                   // yAxis={[{ scaleType: 'band', dataKey: 'month',barGapRatio: 0.9 }]}
//                                   // series={[{ dataKey: 'seoul', label: 'Seoul rainfall', valueFormatter }]}
//                                   // layout="horizontal"
//                                   grid={{ vertical: true }}
//                                   {...chartSetting}
//                                   yAxis={[
//                                     { scaleType: "band", dataKey: "details" },
//                                   ]}
//                                   series={[
//                                     { dataKey: "jobs", valueFormatter },
//                                     { dataKey: "dhaba", valueFormatter },
//                                     { dataKey: "mech", valueFormatter },
//                                     { dataKey: "profile", valueFormatter },
//                                     { dataKey: "convey", valueFormatter },
//                                     { dataKey: "others", valueFormatter },
//                                   ]}
//                                   layout="horizontal"
//                                   // width={500}
//                                   // height={300}
//                                   maxwidth={250}
//                                   height={250}
//                                 />
//                               </Item>
//                             </Grid>
//                           </Grid>
//                         </Grid>
//                       </Grid>

//                       <Grid item xs={12} md={6} style={{ color: "black" }}>
//                         <Item style={{ backgroundColor: "#fff" }}>
//                           <Typography
//                             style={{ color: "black", textAlign: "left" }}
//                           >
//                             Most meals in Dhaba
//                             <MoreHorizIcon
//                               className="MoreHorizIcon"
//                               onClick={toggleModal}
//                             ></MoreHorizIcon>{" "}
//                           </Typography>
//                           <Stack direction="row">
//                             <Typography
//                               style={{
//                                 color: "black",
//                                 fontSize: "25px",
//                                 paddingRight: "20px",
//                               }}
//                             >
//                               3400 Kms
//                               <Chip
//                                 label={
//                                   <span
//                                     style={{
//                                       color: "red",
//                                       fontSize: "12px",
//                                       backgroundColor: "pink",
//                                     }}
//                                   >
//                                     3.2%
//                                     <SouthEastIcon />
//                                   </span>
//                                 }
//                               />
//                               <p style={{ color: "grey", fontSize: "16px" }}>
//                                 Total Kilometers
//                               </p>
//                             </Typography>
//                             <br></br>
//                             <div
//                               style={{
//                                 borderLeft: "2px solid grey",
//                                 height: "150px",
//                                 margin: "0 20px",
//                               }}
//                             ></div>
//                             <Typography style={{ color: "black" }}>
//                               <List>
//                                 <ListItem style={{ paddingBottom: "0px" }}>
//                                   <FormControlLabel
//                                     control={
//                                       <Checkbox
//                                         defaultChecked
//                                         style={{
//                                           color: "grey",
//                                           fontSize: "12px",
//                                         }}
//                                       />
//                                     }
//                                     label={
//                                       <span
//                                         style={{
//                                           color: "grey",
//                                           fontSize: "12px",
//                                         }}
//                                       >
//                                         Trip 1
//                                       </span>
//                                     }
//                                   />
//                                   <ListItemText
//                                     style={{ color: "grey", fontSize: "12px" }}
//                                   >
//                                     Rs 3645
//                                   </ListItemText>
//                                 </ListItem>
//                                 <ListItem style={{ paddingBottom: "0px" }}>
//                                   <FormControlLabel
//                                     control={
//                                       <Checkbox
//                                         defaultChecked
//                                         style={{
//                                           color: "grey",
//                                           fontSize: "12px",
//                                         }}
//                                       />
//                                     }
//                                     label={
//                                       <span
//                                         style={{
//                                           color: "grey",
//                                           fontSize: "12px",
//                                         }}
//                                       >
//                                         Trip 2
//                                       </span>
//                                     }
//                                   />
//                                   <ListItemText
//                                     style={{ color: "grey", fontSize: "12px" }}
//                                   >
//                                     Rs 3645
//                                   </ListItemText>
//                                 </ListItem>
//                                 <ListItem style={{ paddingBottom: "0px" }}>
//                                   <FormControlLabel
//                                     control={
//                                       <Checkbox
//                                         defaultChecked
//                                         style={{
//                                           color: "grey",
//                                           fontSize: "12px",
//                                         }}
//                                       />
//                                     }
//                                     label={
//                                       <span
//                                         style={{
//                                           color: "grey",
//                                           fontSize: "12px",
//                                         }}
//                                       >
//                                         Trip 3
//                                       </span>
//                                     }
//                                   />
//                                   <ListItemText
//                                     style={{ color: "grey", fontSize: "12px" }}
//                                   >
//                                     Rs 3645
//                                   </ListItemText>
//                                 </ListItem>
//                               </List>
//                             </Typography>
//                           </Stack>
//                           {/* Modal
//                           <Modal open={isModalOpen} onClose={toggleModal}>
//                             <div
//                               style={{
//                                 position: "absolute",
//                                 top: "50%",
//                                 left: "50%",
//                                 width: "600px",
//                                 height: "400px",
//                                 transform: "translate(-50%, -50%)",
//                                 backgroundColor: "#fff",
//                                 padding: "20px",
//                                 color: "black",
//                               }}
//                             >
//                               {/* Content of your modal
//                               <Grid container spacing={1}>
//                                 <Stack direction="row">
//                                   <Grid xs={12}>
//                                     <h2>List of Trips</h2>
//                                     <List>
//                                       <ListItem disablePadding>
//                                         <ListItemText>
//                                           Trip 1: Rs 3190
//                                         </ListItemText>
//                                       </ListItem>
//                                       <ListItem disablePadding>
//                                         <ListItemText>
//                                           Trip 2: Rs 2954
//                                         </ListItemText>
//                                       </ListItem>
//                                       <ListItem disablePadding>
//                                         <ListItemText>
//                                           Trip 3: Rs 890
//                                         </ListItemText>
//                                       </ListItem>
//                                       <ListItem disablePadding>
//                                         <ListItemText>
//                                           Trip 4: Rs 1024
//                                         </ListItemText>
//                                       </ListItem>
//                                       <ListItem disablePadding>
//                                         <ListItemText>
//                                           Trip 5: Rs 3645
//                                         </ListItemText>
//                                       </ListItem>
//                                       <ListItem disablePadding>
//                                         <ListItemText>
//                                           Trip 6: Rs 1520
//                                         </ListItemText>
//                                       </ListItem>
//                                       <ListItem disablePadding>
//                                         <ListItemText>
//                                           Trip 7: Rs 2964
//                                         </ListItemText>
//                                       </ListItem>
//                                       <ListItem disablePadding>
//                                         <ListItemText>
//                                           Trip 8: Rs 3044
//                                         </ListItemText>
//                                       </ListItem>
//                                       <ListItem disablePadding>
//                                         <ListItemText>
//                                           Trip 9: Rs 1647
//                                         </ListItemText>
//                                       </ListItem>
//                                       <ListItem disablePadding>
//                                         <ListItemText>
//                                           Trip 10: Rs 445
//                                         </ListItemText>
//                                       </ListItem>
//                                     </List>
//                                   </Grid>
//                                   <Grid
//                                     xs={12}
//                                     sx={{
//                                       justifyContent: "right",
//                                       marginLeft: "50px",
//                                     }}
//                                   >
//                                     <iframe
//                                       src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3562.6962717628603!2d80.92190367521856!3d26.75406687674198!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bfb53706b7d85%3A0xa2330944dc4c56e4!2sRoad%20Pilot%20technologies%20pvt%20ltd!5e0!3m2!1sen!2sin!4v1712893020203!5m2!1sen!2sin"
//                                       height="350"
//                                       style={{ border: "0", width: "400px" }}
//                                       allowfullscreen=""
//                                       loading="lazy"
//                                     ></iframe>
//                                   </Grid>
//                                 </Stack>
//                               </Grid>

//                               <button onClick={toggleModal}>Close</button>
//                             </div>
//                           </Modal>
//                           {/* <div className='map'><SimpleMap></SimpleMap></div>
//                           <Map></Map>
//                           <iframe
//                             src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3562.6962717628603!2d80.92190367521856!3d26.75406687674198!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bfb53706b7d85%3A0xa2330944dc4c56e4!2sRoad%20Pilot%20technologies%20pvt%20ltd!5e0!3m2!1sen!2sin!4v1712893020203!5m2!1sen!2sin"
//                             height="350"
//                             style={{ border: "0", width: "100%" }}
//                             allowfullscreen=""
//                             loading="lazy"
//                           ></iframe>
//                         </Item>
//                       </Grid>
//                     </Grid>
//                   </Grid>
//                   {/* third column
//                   <Grid item xs={12} md={3} style={{ color: "black" }}>
//                     <Grid>
//                       <Item style={{ backgroundColor: "#fff" }}>
//                         <Typography
//                           style={{
//                             textAlign: "left",
//                             fontSize: "20px",
//                             color: "#4d4f5c",
//                           }}
//                         >
//                           User Activity Timeline
//                         </Typography>

//                         <Search>
//                           <SearchIconWrapper style={{ color: "black" }}>
//                             <SearchIcon style={{ color: "black" }} />
//                           </SearchIconWrapper>
//                           <StyledInputBase
//                             style={{ color: "black", borderColor: "black" }}
//                             placeholder="Search…"
//                             inputProps={{ "aria-label": "search" }}
//                           />
//                         </Search>

//                         <Timeline position="alternate">
//                           <TimelineItem>
//                             <TimelineOppositeContent color="black">
//                               09:30 am
//                             </TimelineOppositeContent>
//                             <TimelineSeparator>
//                               <TimelineDot />
//                               <TimelineConnector />
//                             </TimelineSeparator>
//                             <TimelineContent
//                               style={{ color: "black", fontSize: "14px" }}
//                             >
//                               Earned 500 points<br></br>
//                               <Typography
//                                 style={{ color: "black", fontSize: "10px" }}
//                               >
//                                 Earned 500 points
//                               </Typography>
//                             </TimelineContent>
//                           </TimelineItem>
//                           <TimelineItem>
//                             <TimelineOppositeContent color="black">
//                               10:00 am
//                             </TimelineOppositeContent>
//                             <TimelineSeparator>
//                               <TimelineDot color="secondary" />
//                               <TimelineConnector />
//                             </TimelineSeparator>
//                             <TimelineContent
//                               style={{ color: "black", fontSize: "14px" }}
//                             >
//                               Joined the program<br></br>
//                               <Typography
//                                 style={{ color: "black", fontSize: "10px" }}
//                               >
//                                 Customer Joined the program
//                               </Typography>
//                             </TimelineContent>
//                           </TimelineItem>
//                           <TimelineItem>
//                             <TimelineOppositeContent color="black">
//                               12:00 am
//                             </TimelineOppositeContent>
//                             <TimelineSeparator>
//                               <TimelineDot color="success" />
//                               <TimelineConnector />
//                             </TimelineSeparator>
//                             <TimelineContent
//                               style={{ color: "black", fontSize: "14px" }}
//                             >
//                               8 Invoices have been paid<br></br>
//                               <Typography
//                                 style={{ color: "black", fontSize: "10px" }}
//                               >
//                                 Invoices have been paid to the company
//                               </Typography>
//                             </TimelineContent>
//                           </TimelineItem>
//                           <TimelineItem>
//                             <TimelineOppositeContent color="black">
//                               9:00 am
//                             </TimelineOppositeContent>
//                             <TimelineSeparator>
//                               <TimelineDot color="primary" />
//                               <TimelineConnector />
//                             </TimelineSeparator>
//                             <TimelineContent
//                               style={{ color: "black", fontSize: "14px" }}
//                             >
//                               Order #36675<br></br>
//                               <Typography
//                                 style={{ color: "black", fontSize: "10px" }}
//                               >
//                                 Invoices have been paid to the company
//                               </Typography>
//                             </TimelineContent>
//                           </TimelineItem>
//                         </Timeline>
//                       </Item>
//                     </Grid>
//                   </Grid>
//                 </Grid>
//               </Grid>
//               {/* </Grid>
//             </Box>
//           </Box>
//         </Dialog>
//       </React.Fragment>
//     </div>  */}

//     </>
//   );
// }

// import * as React from "react";
// import ListSubheader from "@mui/material/ListSubheader";
// import List from "@mui/material/List";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import Collapse from "@mui/material/Collapse";
// import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
// import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
// import CardMembershipOutlinedIcon from "@mui/icons-material/CardMembershipOutlined";
// import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
// import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
// import { BarChart } from "@mui/x-charts/BarChart";
// import { LineChart } from "@mui/x-charts/LineChart";
// import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
// import WorkIcon from "@mui/icons-material/Work";
// import WorkOffIcon from "@mui/icons-material/WorkOff";
// import StarIcon from "@mui/icons-material/Star";
// import SpeedIcon from "@mui/icons-material/Speed";
// import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

// function DriverView() {
//   const [open, setOpen] = React.useState(true);
//   const handleClick = () => {
//     setOpen(!open);
//   };
//   return (
//     <>
//       <div className="text-black">
//         <div className="flex items-start -mx-4 space-x-2 overflow-x-auto overflow-y-hidden sm:justify-center flex-nowrap bg-gray-100 text-gray-800">
//           <a
//             rel="noopener noreferrer"
//             href="#"
//             className="flex items-center flex-shrink-0 px-5 py-2 border-b-4 border-gray-300 text-gray-600"
//           >
//             Architecto
//           </a>
//           <a
//             rel="noopener noreferrer"
//             href="#"
//             className="flex items-center flex-shrink-0 px-5 py-2 border-b-4 border-gray-300 text-gray-600"
//           >
//             Corrupti
//           </a>
//           <a
//             rel="noopener noreferrer"
//             href="#"
//             className="flex items-center flex-shrink-0 px-5 py-2 border-b-4 border-teal-600 text-gray-900"
//           >
//             Excepturi
//           </a>
//           <a
//             rel="noopener noreferrer"
//             href="#"
//             className="flex items-center flex-shrink-0 px-5 py-2 border-b-4 border-gray-300 text-gray-600"
//           >
//             Consectetur
//           </a>
//         </div>

//         <div className="grid grid-cols-6 grid-rows-9 gap-4">
//           <div className="col-span-2 rounded-lg row-span-1">
//             <div className="max-w-md p-8 sm:flex sm:space-x-6 bg-gray-50 rounded-lg text-gray-800">
//               <div className="flex-shrink-0 w-full mb-6 h-44 sm:h-32 sm:w-32 sm:mb-0">
//                 <img
//                   src="https://source.unsplash.com/100x100/?portrait?1"
//                   alt=""
//                   className="object-cover object-center w-full h-full rounded bg-gray-500"
//                 />
//               </div>
//               <div className="flex flex-col space-y-4">
//                 <div>
//                   <h2 className="text-2xl font-semibold">Leroy Jenkins</h2>
//                   <span className="text-sm text-gray-600">General manager</span>
//                 </div>
//                 <div className="space-y-1">
//                   <span className="flex items-center space-x-2">
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       viewBox="0 0 512 512"
//                       aria-label="Email address"
//                       className="w-4 h-4"
//                     >
//                       <path
//                         fill="currentColor"
//                         d="M274.6,25.623a32.006,32.006,0,0,0-37.2,0L16,183.766V496H496V183.766ZM464,402.693,339.97,322.96,464,226.492ZM256,51.662,454.429,193.4,311.434,304.615,256,268.979l-55.434,35.636L57.571,193.4ZM48,226.492,172.03,322.96,48,402.693ZM464,464H48V440.735L256,307.021,464,440.735Z"
//                       ></path>
//                     </svg>
//                     <span className="text-gray-600">
//                       leroy.jenkins@company.com
//                     </span>
//                   </span>
//                   <span className="flex items-center space-x-2">
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       viewBox="0 0 512 512"
//                       aria-label="Phonenumber"
//                       className="w-4 h-4"
//                     >
//                       <path
//                         fill="currentColor"
//                         d="M449.366,89.648l-.685-.428L362.088,46.559,268.625,171.176l43,57.337a88.529,88.529,0,0,1-83.115,83.114l-57.336-43L46.558,362.088l42.306,85.869.356.725.429.684a25.085,25.085,0,0,0,21.393,11.857h22.344A327.836,327.836,0,0,0,461.222,133.386V111.041A25.084,25.084,0,0,0,449.366,89.648Zm-20.144,43.738c0,163.125-132.712,295.837-295.836,295.837h-18.08L87,371.76l84.18-63.135,46.867,35.149h5.333a120.535,120.535,0,0,0,120.4-120.4v-5.333l-35.149-46.866L371.759,87l57.463,28.311Z"
//                       ></path>
//                     </svg>
//                     <span className="text-gray-600">+25 381 77 983</span>
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="col-span-4 row-span-1 col-start-3">
//             <section className="p-6 my-4 bg-gray-100 text-gray-800">
//               <div className="container grid grid-cols-1 gap-6 mx-auto sm:grid-cols-2 xl:grid-cols-4">
//                 <div className="flex p-4 space-x-4 rounded-lg md:space-x-6 bg-gray-50 text-gray-800">
//                   <div className="flex justify-center p-2 align-middle rounded-lg sm:p-4 bg-teal-600">
//                     <WorkHistoryIcon className="h-9 w-9 text-gray-100" />
//                   </div>
//                   <div className="flex flex-col justify-center align-middle">
//                     <p className="text-3xl font-semibold leading-none">65</p>
//                     <p className="capitalize">Jobs Appliedd</p>
//                   </div>
//                 </div>
//                 <div className="flex p-4 space-x-4 rounded-lg md:space-x-6 bg-gray-50 text-gray-800">
//                   <div className="flex justify-center p-2 align-middle rounded-lg sm:p-4 bg-teal-600">
//                     <WorkIcon className="h-9 w-9 text-gray-100" />
//                   </div>
//                   <div className="flex flex-col justify-center align-middle">
//                     <p className="text-3xl font-semibold leading-none">50</p>
//                     <p className="capitalize">Jobs Accepted</p>
//                   </div>
//                 </div>
//                 <div className="flex p-4 space-x-4 rounded-lg md:space-x-6 bg-gray-50 text-gray-800">
//                   <div className="flex justify-center p-2 align-middle rounded-lg sm:p-4 bg-teal-600">
//                     <WorkOffIcon className="h-9 w-9 text-gray-100" />
//                   </div>
//                   <div className="flex flex-col justify-center align-middle">
//                     <p className="text-3xl font-semibold leading-none">15</p>
//                     <p className="capitalize">Jobs Rejected</p>
//                   </div>
//                 </div>
//                 <div className="flex p-4 space-x-4 rounded-lg md:space-x-6 bg-gray-50 text-gray-800">
//                   <div className="flex justify-center p-2 align-middle rounded-lg sm:p-4 bg-teal-600">
//                     <LocalShippingIcon className="h-9 w-9 text-gray-100" />
//                   </div>
//                   <div className="flex flex-col justify-center align-middle">
//                     <p className="text-3xl font-semibold leading-none">5</p>
//                     <p className="capitalize">Convoy Created</p>
//                   </div>
//                 </div>
//               </div>
//             </section>
//           </div>
//           <div className="col-span-2 bg-white rounded-lg row-span-4 row-start-2">
//             <List
//               sx={{
//                 width: "100%",
//                 maxWidth: 420,
//                 bgcolor: "white",
//                 "& .MuiListSubheader-root": {
//                   backgroundColor: "white",
//                   color: "black",
//                   fontWeight: "600",
//                   fontSize: "1rem",
//                   lineHeight: "2.5rem",
//                   borderBottom: "1px solid #e0e0e0",
//                 },
//               }}
//               component="nav"
//               aria-labelledby="nested-list-subheader"
//             >
//               <ListSubheader component="div">Details</ListSubheader>
//               <ListItemButton>
//                 <ListItemIcon>
//                   <LocalPhoneOutlinedIcon sx={{ color: "#333" }} />
//                 </ListItemIcon>
//                 <ListItemText
//                   primary="Phone Number"
//                   secondary="+91 948254432"
//                   sx={{
//                     "& .MuiListItemText-secondary": {
//                       color: "#333", // Darker color for secondary text
//                     },
//                   }}
//                 />
//               </ListItemButton>
//               <ListItemButton>
//                 <ListItemIcon>
//                   <EmailOutlinedIcon sx={{ color: "#333" }} />
//                 </ListItemIcon>
//                 <ListItemText
//                   primary="Email Address"
//                   secondary="gooddriver@goodcompany.com"
//                   sx={{
//                     "& .MuiListItemText-secondary": {
//                       color: "#333", // Darker color for secondary text
//                     },
//                   }}
//                 />
//               </ListItemButton>
//               <ListItemButton>
//                 <ListItemIcon>
//                   <CardMembershipOutlinedIcon sx={{ color: "#333" }} />
//                 </ListItemIcon>
//                 <ListItemText
//                   primary="Membership"
//                   secondary="Active"
//                   sx={{
//                     "& .MuiListItemText-secondary": {
//                       color: "#333", // Darker color for secondary text
//                     },
//                   }}
//                 />
//               </ListItemButton>
//               <ListSubheader component="div">Documents</ListSubheader>
//               <ListItemButton>
//                 <ListItemIcon>
//                   <AssuredWorkloadIcon sx={{ color: "#333" }} />
//                 </ListItemIcon>
//                 <ListItemText primary="Aadhar Card Front" />
//               </ListItemButton>
//               <ListItemButton>
//                 <ListItemIcon>
//                   <AssuredWorkloadIcon sx={{ color: "#333" }} />
//                 </ListItemIcon>
//                 <ListItemText primary="Aadhar Card Back" />
//               </ListItemButton>
//               <ListItemButton>
//                 <ListItemIcon>
//                   <LocalShippingIcon sx={{ color: "#333" }} />
//                 </ListItemIcon>
//                 <ListItemText primary="Driving License Front" />
//               </ListItemButton>
//               <ListItemButton>
//                 <ListItemIcon>
//                   <LocalShippingIcon sx={{ color: "#333" }} />
//                 </ListItemIcon>
//                 <ListItemText primary="Driving License Back" />
//               </ListItemButton>
//               <div className="flex flex-col space-y-4 justify-center mt-6 mb-4 px-4">
//                 <button className="w-full py-2 bg-green-600 text-white rounded-md hover:bg-green-700 flex items-center justify-center">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-5 w-5 mr-1"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
//                     />
//                   </svg>
//                   Verify Driver
//                 </button>
//                 <div className="flex justify-center space-x-4">
//                   <button className="px-4 py-2 bg-teal-600 text-white rounded-md hover:bg-teal-700 flex-1">
//                     Edit
//                   </button>
//                   <button className="px-4 py-2 bg-gray-200 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-300 flex-1">
//                     Suspend
//                   </button>
//                 </div>
//               </div>
//             </List>
//           </div>
//           <div className="col-span-3 row-span-3 col-start-1 row-start-6 bg-white p-4">
//             <h3 className="text-lg font-medium text-gray-800 mb-4">
//               Weekly Income Trend
//             </h3>
//             <LineChart
//               height={290}
//               series={[
//                 {
//                   data: [2500, 3400, 2900, 3100, 3600, 2800, 3200],
//                   label: "Daily Income",
//                   color: "#2563eb",
//                   curve: "natural",
//                   showMark: true,
//                 },
//               ]}
//               xAxis={[
//                 {
//                   data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
//                   scaleType: "point",
//                   tickLabelStyle: {
//                     angle: 0,
//                     textAnchor: "middle",
//                     fill: "#333333", // Dark text color for x-axis labels
//                   },
//                 },
//               ]}
//               yAxis={[
//                 {
//                   label: "Revenue (₹)",
//                   tickLabelStyle: {
//                     fill: "#333333", // Dark text color for y-axis labels
//                   },
//                   labelStyle: {
//                     fill: "#333333", // Dark text color for y-axis title
//                   },
//                 },
//               ]}
//               grid={{
//                 vertical: true,
//                 horizontal: true,
//                 verticalLineDasharray: "none",
//                 horizontalLineDasharray: "none",
//                 verticalLineColor: "#333333", // Dark grid lines
//                 horizontalLineColor: "#333333", // Dark grid lines
//               }}
//               slotProps={{
//                 legend: {
//                   direction: "row",
//                   position: { vertical: "bottom", horizontal: "middle" },
//                   padding: 10,
//                   itemMarkWidth: 10,
//                   itemMarkHeight: 10,
//                   labelStyle: {
//                     fill: "#333333", // Dark text color for legend
//                   },
//                 },
//               }}
//               margin={{ left: 70, right: 20, top: 20, bottom: 60 }}
//               sx={{
//                 ".MuiLineElement-root": {
//                   strokeWidth: 2,
//                 },
//                 ".MuiMarkElement-root": {
//                   stroke: "#2563eb",
//                   scale: "0.6",
//                   fill: "white",
//                   strokeWidth: 2,
//                 },
//                 ".MuiChartsAxis-label": {
//                   fill: "#333333", // Dark color for all axis labels
//                 },
//                 ".MuiChartsAxis-tick": {
//                   stroke: "#333333", // Dark color for axis ticks
//                 },
//                 ".MuiChartsAxis-line": {
//                   stroke: "#333333", // Dark color for axis lines
//                 },
//                 ".MuiChartsGrid-line": {
//                   stroke: "#333333", // Dark color for grid lines
//                   strokeWidth: 0.5, // Thinner grid lines
//                 },
//               }}
//             />
//           </div>

//           <div className="col-span-3 row-span-3 col-start-4 row-start-6 bg-white p-4">
//             <h3 className="text-lg font-medium text-gray-800 mb-4">
//               Time Spent Analysis
//             </h3>
//             <BarChart
//               series={[
//                 { data: [45, 38, 52, 28], label: "Delivery", color: "#4f46e5" },
//                 { data: [22, 19, 25, 31], label: "Waiting", color: "#f97316" },
//               ]}
//               height={290}
//               xAxis={[
//                 {
//                   data: ["Morning", "Afternoon", "Evening", "Night"],
//                   scaleType: "band",
//                   tickLabelStyle: {
//                     angle: 0,
//                     textAnchor: "middle",
//                     fill: "#333333", // Dark text color for x-axis labels
//                   },
//                 },
//               ]}
//               yAxis={[
//                 {
//                   label: "Hours",
//                   tickLabelStyle: {
//                     fill: "#333333", // Dark text color for y-axis labels
//                   },
//                   labelStyle: {
//                     fill: "#333333", // Dark text color for y-axis title
//                   },
//                 },
//               ]}
//               grid={{
//                 vertical: true,
//                 horizontal: true,
//                 verticalLineDasharray: "none",
//                 horizontalLineDasharray: "none",
//                 verticalLineColor: "#333333", // Dark grid lines
//                 horizontalLineColor: "#333333", // Dark grid lines
//               }}
//               slotProps={{
//                 legend: {
//                   direction: "row",
//                   position: { vertical: "bottom", horizontal: "middle" },
//                   padding: 10,
//                   labelStyle: {
//                     fill: "#333333", // Dark text color for legend
//                   },
//                 },
//               }}
//               margin={{ left: 70, right: 20, top: 20, bottom: 60 }}
//               legend={{ hidden: false }}
//               sx={{
//                 ".MuiChartsAxis-label": {
//                   fill: "#333333", // Dark color for all axis labels
//                 },
//                 ".MuiChartsAxis-tick": {
//                   stroke: "#333333", // Dark color for axis ticks
//                 },
//                 ".MuiChartsAxis-line": {
//                   stroke: "#333333", // Dark color for axis lines
//                 },
//                 ".MuiChartsGrid-line": {
//                   stroke: "#333333", // Dark color for grid lines
//                   strokeWidth: 0.5, // Thinner grid lines
//                 },
//               }}
//             />
//           </div>
//           <div className="col-span-2 row-span-4 col-start-5 row-start-2 bg-white p-4 rounded-lg shadow">
//             <h3 className="text-lg font-semibold text-gray-800 border-b pb-2 mb-4">
//               User Activity
//             </h3>

//             <div className="overflow-y-auto max-h-[500px] pr-2">
//               <div className="space-y-4">
//                 {/* Timeline Item 1 */}
//                 <div className="flex">
//                   <div className="flex flex-col items-center mr-4">
//                     <div className="w-3 h-3 bg-teal-600 rounded-full"></div>
//                     <div className="w-0.5 h-full bg-gray-200"></div>
//                   </div>
//                   <div className="bg-gray-50 p-3 rounded-lg shadow-sm flex-1 mb-2">
//                     <span className="text-xs font-medium text-gray-500 block mb-1">
//                       Today, 9:30 AM
//                     </span>
//                     <p className="text-sm font-medium text-gray-800">
//                       Completed a delivery
//                     </p>
//                     <p className="text-xs text-gray-600 mt-1">
//                       Delivered package #4582 to the customer in Sector 18
//                     </p>
//                   </div>
//                 </div>

//                 {/* Timeline Item 2 */}
//                 <div className="flex">
//                   <div className="flex flex-col items-center mr-4">
//                     <div className="w-3 h-3 bg-blue-600 rounded-full"></div>
//                     <div className="w-0.5 h-full bg-gray-200"></div>
//                   </div>
//                   <div className="bg-gray-50 p-3 rounded-lg shadow-sm flex-1 mb-2">
//                     <span className="text-xs font-medium text-gray-500 block mb-1">
//                       Today, 8:15 AM
//                     </span>
//                     <p className="text-sm font-medium text-gray-800">
//                       Started a new trip
//                     </p>
//                     <p className="text-xs text-gray-600 mt-1">
//                       Began delivering packages for route #A245
//                     </p>
//                   </div>
//                 </div>

//                 {/* Timeline Item 3 */}
//                 <div className="flex">
//                   <div className="flex flex-col items-center mr-4">
//                     <div className="w-3 h-3 bg-orange-500 rounded-full"></div>
//                     <div className="w-0.5 h-full bg-gray-200"></div>
//                   </div>
//                   <div className="bg-gray-50 p-3 rounded-lg shadow-sm flex-1 mb-2">
//                     <span className="text-xs font-medium text-gray-500 block mb-1">
//                       Yesterday, 6:45 PM
//                     </span>
//                     <p className="text-sm font-medium text-gray-800">
//                       Earned achievement
//                     </p>
//                     <p className="text-xs text-gray-600 mt-1">
//                       Earned "Speedy Delivery" badge for completing 50
//                       deliveries on time
//                     </p>
//                   </div>
//                 </div>

//                 {/* Timeline Item 4 */}
//                 <div className="flex">
//                   <div className="flex flex-col items-center mr-4">
//                     <div className="w-3 h-3 bg-green-500 rounded-full"></div>
//                     <div className="w-0.5 h-full bg-gray-200"></div>
//                   </div>
//                   <div className="bg-gray-50 p-3 rounded-lg shadow-sm flex-1 mb-2">
//                     <span className="text-xs font-medium text-gray-500 block mb-1">
//                       Yesterday, 2:30 PM
//                     </span>
//                     <p className="text-sm font-medium text-gray-800">
//                       Payment received
//                     </p>
//                     <p className="text-xs text-gray-600 mt-1">
//                       Received ₹4,500 for completing week's deliveries
//                     </p>
//                   </div>
//                 </div>

//                 {/* Timeline Item 5 */}
//                 <div className="flex">
//                   <div className="flex flex-col items-center mr-4">
//                     <div className="w-3 h-3 bg-purple-500 rounded-full"></div>
//                   </div>
//                   <div className="bg-gray-50 p-3 rounded-lg shadow-sm flex-1">
//                     <span className="text-xs font-medium text-gray-500 block mb-1">
//                       June 5, 2025, 10:15 AM
//                     </span>
//                     <p className="text-sm font-medium text-gray-800">
//                       Document verified
//                     </p>
//                     <p className="text-xs text-gray-600 mt-1">
//                       Your license renewal was successfully verified
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="col-span-2 row-span-2 col-start-3 row-start-4 bg-white rounded-lg shadow overflow-hidden">
//             <div className="p-3 border-b">
//               <h3 className="text-lg font-medium text-gray-800 flex items-center">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   className="h-5 w-5 mr-2 text-teal-600"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
//                   />
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
//                   />
//                 </svg>
//                 Driver Location
//               </h3>
//             </div>
//             <div className="h-[200px]">
//               {" "}
//               {/* Reduced from 300px to 250px */}
//               <iframe
//                 title="Driver Location"
//                 width="100%"
//                 height="100%"
//                 style={{ border: 0 }}
//                 loading="lazy"
//                 allowFullScreen
//                 src="https://www.openstreetmap.org/export/embed.html?bbox=80.54489135742189%2C26.639480166462246%2C81.15257263183595%2C27.03649860918967&amp;layer=mapnik"
//               ></iframe>
//             </div>
//           </div>
//           <div className="col-span-2 row-span-2 col-start-3 row-start-2 bg-white p-4 rounded-lg shadow">
//             <div className="flex justify-between items-center mb-4">
//               <h3 className="text-lg font-semibold text-gray-800">
//                 Performance Overview
//               </h3>
//               <MoreHorizIcon className="text-gray-500 cursor-pointer" />
//             </div>

//             <div className="grid grid-cols-2 gap-4">
//               <div className="flex items-center p-3 rounded-lg bg-blue-50">
//                 <StarIcon className="h-8 w-8 text-blue-500 mr-3" />
//                 <div>
//                   <p className="text-2xl font-semibold">4.8</p>
//                   <p className="text-sm text-gray-600">Average Rating</p>
//                 </div>
//               </div>

//               <div className="flex items-center p-3 rounded-lg bg-green-50">
//                 <SpeedIcon className="h-8 w-8 text-green-500 mr-3" />
//                 <div>
//                   <p className="text-2xl font-semibold">98%</p>
//                   <p className="text-sm text-gray-600">On-time Delivery</p>
//                 </div>
//               </div>

//               <div className="flex items-center p-3 rounded-lg bg-yellow-50">
//                 <DirectionsCarIcon className="h-8 w-8 text-yellow-500 mr-3" />
//                 <div>
//                   <p className="text-2xl font-semibold">3,460</p>
//                   <p className="text-sm text-gray-600">Km Traveled</p>
//                 </div>
//               </div>

//               <div className="flex items-center p-3 rounded-lg bg-purple-50">
//                 <AccessTimeIcon className="h-8 w-8 text-purple-500 mr-3" />
//                 <div>
//                   <p className="text-2xl font-semibold">84%</p>
//                   <p className="text-sm text-gray-600">Efficiency Rate</p>
//                 </div>
//               </div>
//             </div>

//             <div className="mt-3 pt-3 border-t border-gray-200">
//               <div className="flex justify-between items-center">
//                 <p className="text-sm text-gray-600">
//                   Last 30 Days Performance
//                 </p>
//                 <span className="px-2 py-1 bg-green-100 text-green-800 text-xs font-semibold rounded-full">
//                   +12% Improvement
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default DriverView;

import * as React from "react";
import { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import CardMembershipOutlinedIcon from "@mui/icons-material/CardMembershipOutlined";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import SensorOccupiedIcon from "@mui/icons-material/SensorOccupied";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { BarChart } from "@mui/x-charts/BarChart";
import { LineChart } from "@mui/x-charts/LineChart";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import WorkIcon from "@mui/icons-material/Work";
import WorkOffIcon from "@mui/icons-material/WorkOff";
import StarIcon from "@mui/icons-material/Star";
import SpeedIcon from "@mui/icons-material/Speed";
import CloseIcon from "@mui/icons-material/Close";
import {
  Modal,
  IconButton,
  Box,
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
} from "@mui/material";
import EditDriver from "./EditDriver";
import config from "../../../Data/AuthUser";
import { DriverApis, DriversSalary } from "../../../Data/axios";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix for default marker icons in Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
});

// Create custom small dot icon
const createSmallDotIcon = (color = '#2563eb') => {
  return L.divIcon({
    className: 'custom-dot-icon',
    html: `<div style="
      background-color: ${color};
      width: 12px;
      height: 12px;
      border-radius: 50%;
      border: 3px solid white;
      box-shadow: 0 2px 4px rgba(0,0,0,0.3);
      margin: 0;
      padding: 0;
    "></div>`,
    iconSize: [12, 12],
    iconAnchor: [6, 6],
    popupAnchor: [0, -6]
  });
};

// Add CSS for the custom dot icon
const style = document.createElement('style');
style.textContent = `
  .custom-dot-icon {
    background: transparent;
    border: none;
    margin: 0;
    padding: 0;
  }
  .custom-dot-icon div {
    margin: 0;
    padding: 0;
  }
`;
document.head.appendChild(style);

function DriverView() {
  const location = useLocation();
  const navigate = useNavigate();
  const [driverData, setDriverData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Get driverId from state
  const driverId = location.state?.driverId;

  // All other state declarations - MUST be before any conditional returns
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  const [currentDocName, setCurrentDocName] = useState("");
  const [editDriverOpen, setEditDriverOpen] = useState(false);

  // Tab state
  const [activeTab, setActiveTab] = useState("dashboard");

  // Locations tab state
  const [locations, setLocations] = useState([]);
  const [locationsLoading, setLocationsLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [locationAddresses, setLocationAddresses] = useState({});
  const [dashboardMap, setDashboardMap] = useState(null);
  const [locationsMap, setLocationsMap] = useState(null);
  const dashboardMapRef = useRef(null);
  const locationsMapRef = useRef(null);
  const dashboardMapInitialized = useRef(false);
  const locationsMapInitialized = useRef(false);
  const [routeMarkers, setRouteMarkers] = useState([]);

  // Job History tab state
  const [jobHistory, setJobHistory] = useState([]);
  const [jobHistoryLoading, setJobHistoryLoading] = useState(false);
  const [jobHistoryPage, setJobHistoryPage] = useState(1);
  const [jobHistoryLimit] = useState(10);
  const [jobHistoryTotalPages, setJobHistoryTotalPages] = useState(0);
  const [jobHistoryStatus, setJobHistoryStatus] = useState("");
  const [jobHistorySearch, setJobHistorySearch] = useState("");
  const [jobHistoryFrom, setJobHistoryFrom] = useState("");
  const [jobHistoryTo, setJobHistoryTo] = useState("");
  const [jobHistoryLoaded, setJobHistoryLoaded] = useState(false);


  // Finance tab state
  const [salaryRows, setSalaryRows] = useState([]);
  const [salaryLoading, setSalaryLoading] = useState(false);
  const [salaryPage, setSalaryPage] = useState(1);
  const [salaryTotalPages, setSalaryTotalPages] = useState(0);
  const [salaryStatus, setSalaryStatus] = useState("");
  const [salaryFrom, setSalaryFrom] = useState("");
  const [salaryTo, setSalaryTo] = useState("");
  const [salaryLoaded, setSalaryLoaded] = useState(false);


  // Filter state
  const [filterDate, setFilterDate] = useState('');
  const [filterFromDate, setFilterFromDate] = useState('');
  const [filterToDate, setFilterToDate] = useState('');
  const [applyFilter, setApplyFilter] = useState(false);

  // Fetch driver data if not provided
  React.useEffect(() => {
    const fetchDriverData = async () => {
      if (!driverId) {
        console.log("No driverId found");
        setError("Driver ID not found");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        console.log("Fetching driver data for ID:", driverId);
        const response = await DriverApis.getbyId(driverId);
        console.log("Driver data response:", response);

        if (response && (response.user_id || response.id)) {
          console.log("Setting driver data:", response);
          setDriverData(response);
          setError(null);
        } else {
          console.log("Invalid driver response");
          setError("Driver not found");
        }
      } catch (err) {
        console.error("Error fetching driver data:", err);
        setError("Failed to fetch driver details");
      } finally {
        setLoading(false);
      }
    };

    // Use data from state if available, otherwise fetch by driverId
    console.log("DriverView location.state:", location.state);
    if (location.state?.data) {
      let data = location.state.data;
      if (data.data) data = data.data;
      console.log("Using data from state:", data);
      setDriverData(data);
      setLoading(false);
    } else if (driverId) {
      console.log("No data in state, fetching by driverId");
      fetchDriverData();
    } else {
      console.log("No data or driverId found");
      setError("No driver data found");
      setLoading(false);
    }
  }, [location.state, driverId]);

  // Handle error state
  React.useEffect(() => {
    if (error) {
      alert(error);
      navigate("/Users/Drivers", { replace: true });
    }
  }, [error, navigate]);

  // Load locations when switching to Locations tab
  useEffect(() => {
    if (activeTab === 'locations' && locations.length === 0) {
      fetchLiveLocations();
    }
  }, [activeTab]);

  // Load job history when switching to Job History tab
  useEffect(() => {
    if (activeTab === 'jobs' && driverData?.user_id && !jobHistoryLoaded) {
      setJobHistoryLoaded(true);
      fetchJobHistory({ page: 1 });
    }
  }, [activeTab, driverData, jobHistoryLoaded]);

  // Load salary history when switching to Finance tab
  useEffect(() => {
    if (activeTab === 'finance' && driverData?.user_id && !salaryLoaded) {
      setSalaryLoaded(true);
      fetchSalary({ page: 1 });
    }
  }, [activeTab, driverData, salaryLoaded]);

  const fetchJobHistory = async ({ page = 1, status = "", search = "", appliedFrom = "", appliedTo = "" } = {}) => {
    if (!driverData?.user_id) return;
    setJobHistoryLoading(true);
    try {
      const result = await DriverApis.getJobHistory(driverData.user_id, {
        page,
        limit: jobHistoryLimit,
        status: status || undefined,
        search: search || undefined,
        appliedFrom: appliedFrom || undefined,
        appliedTo: appliedTo || undefined,
      });
      const data = result?.data || {};
      setJobHistory(Array.isArray(data.records) ? data.records : []);
      setJobHistoryTotalPages(data.total_pages || 0);
      setJobHistoryPage(page);
    } catch (err) {
      console.error("Error fetching job history:", err);
      setJobHistory([]);
      setJobHistoryTotalPages(0);
    } finally {
      setJobHistoryLoading(false);
    }
  };

  const applyJobHistoryFilters = () => {
    fetchJobHistory({
      page: 1,
      status: jobHistoryStatus,
      search: jobHistorySearch,
      appliedFrom: jobHistoryFrom,
      appliedTo: jobHistoryTo,
    });
  };

  const clearJobHistoryFilters = () => {
    setJobHistoryStatus("");
    setJobHistorySearch("");
    setJobHistoryFrom("");
    setJobHistoryTo("");
    fetchJobHistory({ page: 1 });
  };

  const handleJobHistoryPage = (page) => {
    if (page < 1 || page > jobHistoryTotalPages) return;
    fetchJobHistory({
      page,
      status: jobHistoryStatus,
      search: jobHistorySearch,
      appliedFrom: jobHistoryFrom,
      appliedTo: jobHistoryTo,
    });
  };

  const fetchSalary = async ({ page = 1, status = "", from = "", to = "" } = {}) => {
    if (!driverData?.user_id) return;
    setSalaryLoading(true);
    try {
      const timestamps = from && to ? `${from},${to}` : from || to || undefined;
      const result = await DriversSalary.getDriverSalary({
        user_id: driverData.user_id,
        page,
        limit: 10,
        status: status || undefined,
        timestamps,
      });
      setSalaryRows(result.success ? result.data || [] : []);
      setSalaryTotalPages(result.pagination?.total_pages || 0);
      setSalaryPage(page);
    } catch (err) {
      console.error("Error fetching salary history:", err);
      setSalaryRows([]);
      setSalaryTotalPages(0);
    } finally {
      setSalaryLoading(false);
    }
  };

  const applySalaryFilters = () => {
    fetchSalary({ page: 1, status: salaryStatus, from: salaryFrom, to: salaryTo });
  };

  const clearSalaryFilters = () => {
    setSalaryStatus("");
    setSalaryFrom("");
    setSalaryTo("");
    fetchSalary({ page: 1 });
  };

  const handleSalaryPage = (page) => {
    if (page < 1 || page > salaryTotalPages) return;
    fetchSalary({ page, status: salaryStatus, from: salaryFrom, to: salaryTo });
  };

  const getSalaryStatusInfo = (status) => {
    const statusMap = {
      "0": { label: "Initiated", color: "#ff9800", bgColor: "#fff3e0" },
      "1": { label: "Processed", color: "#2196f3", bgColor: "#e3f2fd" },
      "2": { label: "Transferred", color: "#4caf50", bgColor: "#e8f5e9" },
    };
    return statusMap[String(status)] || { label: "Unknown", color: "#757575", bgColor: "#f5f5f5" };
  };

  const getDepositStatusInfo = (status) => {
    const statusMap = {
      "0": { label: "Initiated", color: "#ff9800", bgColor: "#fff3e0" },
      "1": { label: "Processed", color: "#2196f3", bgColor: "#e3f2fd" },
      "2": { label: "Settled", color: "#4caf50", bgColor: "#e8f5e9" },
    };
    return statusMap[String(status)] || { label: "Initiated", color: "#ff9800", bgColor: "#fff3e0" };
  };

  const getJobHistoryStatusInfo = (status) => {
    const statusMap = {
      "0": { label: "Rejected", color: "#f44336", bgColor: "#ffebee" },
      "1": { label: "Pending", color: "#ff9800", bgColor: "#fff3e0" },
      "2": { label: "Accepted", color: "#4caf50", bgColor: "#e8f5e9" },
    };
    return statusMap[status] || { label: "Pending", color: "#ff9800", bgColor: "#fff3e0" };
  };

  const formatJobDate = (value) => {
    if (!value) return "N/A";
    const raw = String(value).trim();
    let date;
    if (/^\d+$/.test(raw) && raw.length >= 12) {
      // Epoch milliseconds
      date = new Date(Number(raw));
    } else {
      // Normalize "YYYY-MM-DD HH:mm:ss" -> ISO; naive values are UTC
      const hasTimezone = /(Z|[+-]\d{2}:\d{2})$/.test(raw);
      const normalized = raw.replace(" ", "T");
      date = new Date(hasTimezone ? normalized : normalized + "Z");
    }
    if (isNaN(date.getTime())) return raw;
    return new Intl.DateTimeFormat("en-US", {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    }).format(date);
  };

  // Add new markers to map when more locations are loaded
  useEffect(() => {
    if (activeTab === 'locations' && locationsMap && !locationsMap._removed && locations.length > routeMarkers.length) {
      const newLocations = locations.slice(routeMarkers.length);
      addMarkersToMap(newLocations);
    }
  }, [locations, routeMarkers.length, activeTab]);

  // Handle tab switching and map initialization
  useEffect(() => {
    let cleanupTimer = null;

    // When switching away from a tab, clean up its map
    const cleanupMaps = () => {
      // Clean up locations map when leaving locations tab
      if (activeTab !== 'locations' && locationsMap && !locationsMap._removed) {
        try {
          locationsMap._removed = true;
          locationsMap.remove();
          setLocationsMap(null);
          setRouteMarkers([]);
          locationsMapInitialized.current = false;
        } catch (error) {
          console.log('Error cleaning up locations map:', error);
        }
        // Reset pagination and filters when leaving locations tab
        setCurrentPage(1);
        setHasMore(true);
        setFilterDate('');
        setFilterFromDate('');
        setFilterToDate('');
        setApplyFilter(false);
      }

      // Clean up dashboard map when leaving dashboard tab
      if (activeTab !== 'dashboard' && dashboardMap && !dashboardMap._removed) {
        try {
          dashboardMap._removed = true;
          dashboardMap.remove();
          setDashboardMap(null);
          dashboardMapInitialized.current = false;
        } catch (error) {
          console.log('Error cleaning up dashboard map:', error);
        }
      }
    };

    // Clean up maps when tab changes
    cleanupMaps();

    // Initialize dashboard map
    if (activeTab === 'dashboard' && driverData?.live_locations?.[0] && !dashboardMapInitialized.current) {
      cleanupTimer = setTimeout(() => {
        initDashboardMap();
      }, 150);
    }

    // Initialize locations map
    if (activeTab === 'locations' && locations.length > 0 && !locationsMapInitialized.current) {
      cleanupTimer = setTimeout(() => {
        initLocationsMap();
      }, 150);
    }

    // Invalidate map size when tab becomes active and map exists
    if (activeTab === 'dashboard' && dashboardMap && !dashboardMap._removed) {
      cleanupTimer = setTimeout(() => {
        if (dashboardMap && !dashboardMap._removed) {
          dashboardMap.invalidateSize();
        }
      }, 200);
    }
    if (activeTab === 'locations' && locationsMap && !locationsMap._removed) {
      cleanupTimer = setTimeout(() => {
        if (locationsMap && !locationsMap._removed) {
          locationsMap.invalidateSize();
        }
      }, 200);
    }

    return () => {
      if (cleanupTimer) clearTimeout(cleanupTimer);
    };
  }, [activeTab, locations.length, driverData, applyFilter]);

  // Cleanup maps on unmount - single cleanup point
  useEffect(() => {
    return () => {
      // Only cleanup if maps haven't been already cleaned by tab switching
      // Safely remove dashboard map
      if (dashboardMap && !dashboardMap._removed) {
        try {
          dashboardMap._removed = true;
          dashboardMap.remove();
        } catch (error) {
          console.log('Dashboard map already removed or error during cleanup:', error);
        }
      }

      // Safely remove locations map
      if (locationsMap && !locationsMap._removed) {
        try {
          locationsMap._removed = true;
          locationsMap.remove();
        } catch (error) {
          console.log('Locations map already removed or error during cleanup:', error);
        }
      }

      // Reset flags
      dashboardMapInitialized.current = false;
      locationsMapInitialized.current = false;
    };
  }, []);

  // Helper function to format UTC time to local time
  const formatToLocalTime = (utcDateString) => {
    if (!utcDateString) return "N/A";
    const utcDate = new Date(utcDateString);
    const dd = String(utcDate.getDate()).padStart(2, "0");
    const mm = String(utcDate.getMonth() + 1).padStart(2, "0");
    const hh = String(utcDate.getHours()).padStart(2, "0");
    const min = String(utcDate.getMinutes()).padStart(2, "0");
    const ss = String(utcDate.getSeconds()).padStart(2, "0");
    return `${dd}-${mm}-${utcDate.getFullYear()} ${hh}:${min}:${ss}`;
  };

  // Reverse geocoding function using Nominatim API (free)
  const reverseGeocode = async (lat, lon) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=18&addressdetails=1`,
        {
          headers: {
            'Accept-Language': 'en'
          }
        }
      );
      const data = await response.json();
      return data.display_name || `${lat}, ${lon}`;
    } catch (error) {
      console.error("Reverse geocoding error:", error);
      return `${lat}, ${lon}`;
    }
  };

  // Fetch live locations for the Locations tab
  const fetchLiveLocations = async (page = 1, append = false) => {
    if (!driverData?.user_id) return;

    if (page === 1) {
      setLocationsLoading(true);
    } else {
      setLoadingMore(true);
    }

    try {
      // Build query parameters
      let queryParams = `per_page=${page === 1 ? 100 : 10}&page=${page}`;

      // Add date filter if specified
      if (filterDate) {
        queryParams += `&date=${filterDate}`;
      }

      // Add date range filter if specified
      if (filterFromDate && filterToDate) {
        queryParams += `&from_date=${filterFromDate}&to_date=${filterToDate}`;
      }

      const response = await fetch(
        `${config.apiBaseUrl}/getLiveLocationByUserId/${driverData.user_id}?${queryParams}`
      );
      const result = await response.json();

      if (result.status === 'success' && result.data?.data) {
        const newLocations = result.data.data;

        if (append) {
          setLocations(prev => [...prev, ...newLocations]);
        } else {
          setLocations(newLocations);
        }

        // Check if there are more records
        setHasMore(result.data.current_page < result.data.last_page);

        // Fetch addresses for new locations (in background, don't block UI)
        const addresses = { ...locationAddresses };
        newLocations.forEach(async (loc) => {
          if (!addresses[loc.id]) {
            const address = await reverseGeocode(loc.latitude, loc.longitude);
            addresses[loc.id] = address;
            setLocationAddresses(prev => ({ ...prev, [loc.id]: address }));
          }
        });
      }
    } catch (error) {
      console.error("Error fetching live locations:", error);
    } finally {
      if (page === 1) {
        setLocationsLoading(false);
      } else {
        setLoadingMore(false);
      }
    }
  };

  // Reset and apply filters
  const handleApplyFilter = () => {
    setApplyFilter(true);
    setCurrentPage(1);
    setHasMore(true);

    // Clear existing data and map
    setLocations([]);
    setRouteMarkers([]);
    setLocationAddresses({});

    // Clear map markers if map exists
    if (locationsMap && !locationsMap._removed) {
      routeMarkers.forEach(marker => marker.remove());
      setRouteMarkers([]);
    }

    // Reset map initialization flag to force reinitialization
    locationsMapInitialized.current = false;

    // Fetch filtered data
    fetchLiveLocations(1, false);
  };

  // Clear filters
  const handleClearFilter = () => {
    setFilterDate('');
    setFilterFromDate('');
    setFilterToDate('');
    setApplyFilter(false);
    setCurrentPage(1);
    setHasMore(true);

    // Clear existing data and map
    setLocations([]);
    setRouteMarkers([]);
    setLocationAddresses({});

    // Clear map markers if map exists
    if (locationsMap && !locationsMap._removed) {
      routeMarkers.forEach(marker => marker.remove());
      setRouteMarkers([]);
    }

    // Reset map initialization flag to force reinitialization
    locationsMapInitialized.current = false;

    // Fetch all data
    fetchLiveLocations(1, false);
  };

  // Load more locations when scrolling to end
  const handleLoadMore = () => {
    if (!loadingMore && hasMore) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      fetchLiveLocations(nextPage, true);
    }
  };

  // Handle scroll on table container with debouncing
  let scrollTimeout = null;
  const handleTableScroll = (e) => {
    if (scrollTimeout) clearTimeout(scrollTimeout);

    scrollTimeout = setTimeout(() => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      if (scrollHeight - (scrollTop + clientHeight) < 50 && !loadingMore && hasMore) {
        handleLoadMore();
      }
    }, 100);
  };

  // Initialize dashboard map with pin and tooltip
  const initDashboardMap = () => {
    if (!driverData?.live_locations?.[0]) return;

    // Check if container exists and is not already initialized
    if (!dashboardMapRef.current || dashboardMapInitialized.current) return;

    // Remove existing map if it exists (safely)
    if (dashboardMap && !dashboardMap._removed) {
      try {
        dashboardMap.remove();
      } catch (error) {
        console.log('Error removing existing dashboard map:', error);
      }
      setDashboardMap(null);
    }

    // Clear the container
    if (dashboardMapRef.current) {
      while (dashboardMapRef.current.firstChild) {
        dashboardMapRef.current.removeChild(dashboardMapRef.current.firstChild);
      }
    }

    const liveLoc = driverData.live_locations[0];
    const lat = parseFloat(liveLoc.latitude);
    const lon = parseFloat(liveLoc.longitude);

    const map = L.map(dashboardMapRef.current).setView([lat, lon], 13);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors'
    }).addTo(map);

    // Add marker with custom tooltip showing local time
    const marker = L.marker([lat, lon]).addTo(map);
    const localTime = formatToLocalTime(liveLoc.created_at);

    marker.bindTooltip(
      `<div style="font-family: Arial, sans-serif; font-size: 14px;">
        <strong>Driver Location</strong><br/>
        <span style="color: #666;">Updated: ${localTime}</span>
      </div>`,
      {
        permanent: false,
        direction: 'top',
        offset: [0, -20]
      }
    );

    marker.openTooltip();
    map._removed = false;
    setDashboardMap(map);
    dashboardMapInitialized.current = true;
  };

  // Initialize locations map with individual small dot markers
  const initLocationsMap = () => {
    if (locations.length === 0) return;

    // Check if container exists and is not already initialized
    if (!locationsMapRef.current || locationsMapInitialized.current) return;

    // Remove existing map if it exists (safely)
    if (locationsMap && !locationsMap._removed) {
      try {
        locationsMap.remove();
      } catch (error) {
        console.log('Error removing existing locations map:', error);
      }
      setLocationsMap(null);
    }

    // Clear the container
    if (locationsMapRef.current) {
      while (locationsMapRef.current.firstChild) {
        locationsMapRef.current.removeChild(locationsMapRef.current.firstChild);
      }
    }

    const firstLoc = locations[locations.length - 1]; // Most recent
    const lat = parseFloat(firstLoc.latitude);
    const lon = parseFloat(firstLoc.longitude);

    const map = L.map(locationsMapRef.current).setView([lat, lon], 12);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors'
    }).addTo(map);

    // Add individual small dot markers for each location (no connecting route)
    const markers = [];

    locations.slice().reverse().forEach((loc, index) => {
      const position = [parseFloat(loc.latitude), parseFloat(loc.longitude)];

      // Use small dot icon instead of full marker
      const marker = L.marker(position, { icon: createSmallDotIcon() }).addTo(map);
      const localTime = formatToLocalTime(loc.created_at);
      const address = locationAddresses[loc.id] || `${loc.latitude}, ${loc.longitude}`;

      marker.bindTooltip(
        `<div style="font-family: Arial, sans-serif; font-size: 12px; max-width: 250px;">
          <strong>Location #${locations.length - index}</strong><br/>
          <span style="color: #666;">Time: ${localTime}</span><br/>
          <span style="color: #666; font-size: 11px;">${address}</span>
        </div>`,
        {
          permanent: false,
          direction: 'top',
          offset: [0, -20]
        }
      );

      markers.push(marker);

      // Click handler to select location
      marker.on('click', () => {
        setSelectedLocation(loc);
        map.setView(position, 15);
      });
    });

    setRouteMarkers(markers);
    map._removed = false;
    setLocationsMap(map);
    locationsMapInitialized.current = true;
  };

  // Add new markers to existing map when more data is loaded
  const addMarkersToMap = (newLocations) => {
    if (!locationsMap || locationsMap._removed) return;

    const markers = [...routeMarkers];
    const startIndex = locations.length - newLocations.length;

    newLocations.slice().reverse().forEach((loc, index) => {
      const position = [parseFloat(loc.latitude), parseFloat(loc.longitude)];

      // Use small dot icon
      const marker = L.marker(position, { icon: createSmallDotIcon() }).addTo(locationsMap);
      const localTime = formatToLocalTime(loc.created_at);
      const address = locationAddresses[loc.id] || `${loc.latitude}, ${loc.longitude}`;

      marker.bindTooltip(
        `<div style="font-family: Arial, sans-serif; font-size: 12px; max-width: 250px;">
          <strong>Location #${startIndex - index}</strong><br/>
          <span style="color: #666;">Time: ${localTime}</span><br/>
          <span style="color: #666; font-size: 11px;">${address}</span>
        </div>`,
        {
          permanent: false,
          direction: 'top',
          offset: [0, -20]
        }
      );

      markers.push(marker);

      // Click handler to select location
      marker.on('click', () => {
        setSelectedLocation(loc);
        locationsMap.setView(position, 15);
      });
    });

    setRouteMarkers(markers);
  };

  // Handle location row click
  const handleLocationClick = (loc) => {
    setSelectedLocation(loc);
    if (locationsMap && !locationsMap._removed) {
      const lat = parseFloat(loc.latitude);
      const lon = parseFloat(loc.longitude);
      locationsMap.setView([lat, lon], 15);

      // Find and highlight the corresponding marker
      routeMarkers.forEach((marker, index) => {
        const markerPos = marker.getLatLng();
        if (Math.abs(markerPos.lat - lat) < 0.0001 && Math.abs(markerPos.lng - lon) < 0.0001) {
          marker.openTooltip();
        }
      });
    }
  };

const formatTimelineDate = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);

  // Format: "Today, 9:30 AM" or "June 5, 2025, 10:15 AM"
  const isToday = new Date().toDateString() === date.toDateString();
  const isYesterday = new Date(Date.now() - 86400000).toDateString() === date.toDateString();

  let prefix = "";
  if (isToday) {
    prefix = "Today, ";
  } else if (isYesterday) {
    prefix = "Yesterday, ";
  } else {
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    prefix = `${dd}-${mm}-${date.getFullYear()}, `;
  }

  return prefix + date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
};

  // Helper function for safely displaying data
  const safe = (val, fallback = "N/A") =>
    val !== null && val !== undefined && val !== "" ? val : fallback;

  // Fixed handleDocumentClick function with proper closing bracket
  const handleDocumentClick = (docType) => {
    setCurrentDocName(docType);
    setLoading(true);
    setImageModalOpen(true);
    let imgSrc;

    // Get document URLs from API response
    const documents = driverData?.documents;
    
    switch (docType) {
      case "Aadhar Card Front":
        imgSrc = documents?.adhar_front && documents.adhar_front !== "documents/" 
          ? `${config.apiImageUrl}${documents.adhar_front}` 
          : "https://via.placeholder.com/400x250?text=Aadhar+Front+Not+Available";
        break;
      case "Aadhar Card Back":
        imgSrc = documents?.adhar_back && documents.adhar_back !== "documents/" 
          ? `${config.apiImageUrl}${documents.adhar_back}` 
          : "https://via.placeholder.com/400x250?text=Aadhar+Back+Not+Available";
        break;
      case "Driving License Front":
        imgSrc = documents?.license_front && documents.license_front !== "documents/" 
          ? `${config.apiImageUrl}${documents.license_front}` 
          : "https://via.placeholder.com/400x250?text=License+Front+Not+Available";
        break;
      case "Driving License Back":
        imgSrc = documents?.license_back && documents.license_back !== "documents/" 
          ? `${config.apiImageUrl}${documents.license_back}` 
          : "https://via.placeholder.com/400x250?text=License+Back+Not+Available";
        break;
      case "Character Certificate":
        imgSrc = documents?.character_certificate && documents.character_certificate !== "documents/" 
          ? `${config.apiImageUrl}${documents.character_certificate}` 
          : "https://via.placeholder.com/400x250?text=Character+Certificate+Not+Available";
        break;
      default:
        imgSrc = "https://via.placeholder.com/400x250?text=Document+Not+Found";
    }

    setCurrentImage(imgSrc);
    // Simulate loading completion
    setTimeout(() => setLoading(false), 500);
  };
  const handleEditClick = () => {
    setEditDriverOpen(true);
  };
  const handleDriverUpdated = () => {
    // Refresh driver data after update
    // This would typically involve refetching the data from API
    // For now we'll just notify the user
    alert("Driver information updated successfully!");

    // In a real app, you might want to refetch the data:
    // fetchDriverData(driverData.user_id).then(data => {
    //   setDriverData(data);
    // });
  };
  return (
    <>
      {/* Loading state */}
      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
          <CircularProgress />
        </Box>
      )}

      {/* Error state */}
      {(error || !driverData) && !loading && (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
          <Typography variant="h6" color="error">
            {error || "Driver not found"}
          </Typography>
        </Box>
      )}

      {/* Main content - only render when data is loaded and no error */}
      {!loading && driverData && !error && (
        <div className="text-black">
        <div className="flex items-start -mx-4 space-x-2 overflow-x-auto overflow-y-hidden sm:justify-center flex-nowrap bg-gray-100 text-gray-800">
          <button
            onClick={() => setActiveTab('dashboard')}
            className={`flex items-center flex-shrink-0 px-5 py-2 border-b-4 ${
              activeTab === 'dashboard'
                ? 'border-teal-600 text-gray-900'
                : 'border-gray-300 text-gray-600'
            }`}
          >
            Dashboard
          </button>
          <button
            onClick={() => setActiveTab('locations')}
            className={`flex items-center flex-shrink-0 px-5 py-2 border-b-4 ${
              activeTab === 'locations'
                ? 'border-teal-600 text-gray-900'
                : 'border-gray-300 text-gray-600'
            }`}
          >
            Locations
          </button>
          <button
            onClick={() => setActiveTab('jobs')}
            className={`flex items-center flex-shrink-0 px-5 py-2 border-b-4 ${
              activeTab === 'jobs'
                ? 'border-teal-600 text-gray-900'
                : 'border-gray-300 text-gray-600'
            }`}
          >
            Job History
          </button>
          <button
            onClick={() => setActiveTab('finance')}
            className={`flex items-center flex-shrink-0 px-5 py-2 border-b-4 ${
              activeTab === 'finance'
                ? 'border-teal-600 text-gray-900'
                : 'border-gray-300 text-gray-600'
            }`}
          >
            Finance
          </button>
        </div>

        {activeTab === 'dashboard' ? (
          <>
        {/* Main grid layout */}
        <div className="grid grid-cols-6 grid-rows-8 gap-4">
          {/* Box 1 - Driver Profile Card */}
          <div className="col-span-2 row-span-1 bg-white rounded-lg shadow">
            <div className="p-3 sm:flex sm:space-x-6 bg-gray-50 rounded-lg text-gray-800">
              <div className="flex-shrink-0 w-full mb-6 h-44 sm:h-32 sm:w-32 sm:mb-0">
                {driverData?.image && driverData.image !== "users/" ? (
                  <img
                    src={`${config.apiImageUrl}${driverData.image}`}
                    alt="Driver Profile"
                    className="object-cover object-center w-full h-full rounded bg-gray-500"
                  />
                ) : (
                  <div className="object-cover object-center w-full h-full rounded bg-gray-500 flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="white"
                      className="w-12 h-12"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                      />
                    </svg>
                  </div>
                )}
              </div>
              <div className="flex flex-col space-y-4">
                <div>
                  <h2 className="text-2xl font-semibold">
                    {safe(driverData?.username, "Driver")}
                  </h2>
                  <span className="text-sm text-gray-600">
                    ID: {safe(driverData?.user_id)}
                  </span>
                  <div className="flex items-center mt-1">
                    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                      driverData?.Status === "1" 
                        ? "bg-green-100 text-green-800" 
                        : "bg-red-100 text-red-800"
                    }`}>
                      {driverData?.Status === "1" ? "Active" : "Inactive"}
                    </span>
                    {driverData?.verified === "1" && (
                      <span className="ml-2 inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                        ✓ Verified
                      </span>
                    )}
                  </div>
                </div>
                <div className="space-y-1">
                  <span className="flex items-center space-x-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      aria-label="Email address"
                      className="w-4 h-4"
                    >
                      <path
                        fill="currentColor"
                        d="M274.6,25.623a32.006,32.006,0,0,0-37.2,0L16,183.766V496H496V183.766ZM464,402.693,339.97,322.96,464,226.492ZM256,51.662,454.429,193.4,311.434,304.615,256,268.979l-55.434,35.636L57.571,193.4ZM48,226.492,172.03,322.96,48,402.693ZM464,464H48V440.735L256,307.021,464,440.735Z"
                      ></path>
                    </svg>
                    <span className="text-gray-600">
                      {safe(driverData?.email)}
                    </span>
                  </span>
                  <span className="flex items-center space-x-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      aria-label="Phonenumber"
                      className="w-4 h-4"
                    >
                      <path
                        fill="currentColor"
                        d="M449.366,89.648l-.685-.428L362.088,46.559,268.625,171.176l43,57.337a88.529,88.529,0,0,1-83.115,83.114l-57.336-43L46.558,362.088l42.306,85.869.356.725.429.684a25.085,25.085,0,0,0,21.393,11.857h22.344A327.836,327.836,0,0,0,461.222,133.386V111.041A25.084,25.084,0,0,0,449.366,89.648Zm-20.144,43.738c0,163.125-132.712,295.837-295.836,295.837h-18.08L87,371.76l84.18-63.135,46.867,35.149h5.333a120.535,120.535,0,0,0,120.4-120.4v-5.333l-35.149-46.866L371.759,87l57.463,28.311Z"
                      ></path>
                    </svg>
                    <span className="text-gray-600">
                      {safe(driverData?.phone)}
                    </span>
                  </span>
                  <span className="flex items-center space-x-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      aria-label="Location"
                      className="w-4 h-4"
                    >
                      <path
                        fill="currentColor"
                        d="M256 32C167.78 32 96 103.78 96 192c0 2.7.17 5.33.5 7.94C98.46 282.62 172.46 448 256 448s157.54-165.38 159.5-248.06c.33-2.61.5-5.24.5-7.94C416 103.78 344.22 32 256 32zm0 224a64 64 0 1164-64 64.07 64.07 0 01-64 64z"
                      ></path>
                    </svg>
                    <span className="text-gray-600 text-sm">
                      {`${safe(driverData?.address)}, ${safe(driverData?.state)} - ${safe(driverData?.pincode)}`}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Box 2 - Stats Overview */}
          <div className="col-span-4 row-span-1 col-start-3">
            <section className="p-5 my-1 bg-gray-100 text-gray-800">
              <div className="container grid grid-cols-2 gap-4 mx-auto lg:grid-cols-2 xl:grid-cols-4">
                <div className="flex p-4 space-x-3 rounded-lg bg-gray-50 text-gray-800 min-w-0">
                  <div className="flex justify-center p-3 align-middle rounded-lg bg-blue-600 flex-shrink-0">
                    <WorkHistoryIcon className="h-7 w-7 text-gray-100" />
                  </div>
                  <div className="flex flex-col justify-center align-middle min-w-0 flex-1">
                    <p className="text-xl font-semibold leading-none truncate">
                      {safe(driverData?.job_applications?.length, "0")}
                    </p>
                    <p className="capitalize text-sm text-gray-600 truncate">Jobs Applied</p>
                  </div>
                </div>
                <div className="flex p-4 space-x-3 rounded-lg bg-gray-50 text-gray-800 min-w-0">
                  <div className="flex justify-center p-3 align-middle rounded-lg bg-green-600 flex-shrink-0">
                    <WorkIcon className="h-7 w-7 text-gray-100" />
                  </div>
                  <div className="flex flex-col justify-center align-middle min-w-0 flex-1">
                    <p className="text-xl font-semibold leading-none truncate">
                      {safe(driverData?.drive_data?.jobs, "0")}
                    </p>
                    <p className="capitalize text-sm text-gray-600 truncate">Jobs Completed</p>
                  </div>
                </div>
                <div className="flex p-4 space-x-3 rounded-lg bg-gray-50 text-gray-800 min-w-0">
                  <div className="flex justify-center p-3 align-middle rounded-lg bg-purple-600 flex-shrink-0">
                    <LocalShippingIcon className="h-7 w-7 text-gray-100" />
                  </div>
                  <div className="flex flex-col justify-center align-middle min-w-0 flex-1">
                    <p className="text-xl font-semibold leading-none truncate">
                      {safe(driverData?.convoy_model?.length, "0")}
                    </p>
                    <p className="capitalize text-sm text-gray-600 truncate">Convoys Created</p>
                  </div>
                </div>
                <div className="flex p-4 space-x-3 rounded-lg bg-gray-50 text-gray-800 min-w-0">
                  <div className="flex justify-center p-3 align-middle rounded-lg bg-teal-600 flex-shrink-0">
                    <SpeedIcon className="h-7 w-7 text-gray-100" />
                  </div>
                  <div className="flex flex-col justify-center align-middle min-w-0 flex-1">
                    <p className="text-xl font-semibold leading-none truncate">
                      {safe(driverData?.drive_data?.experience, "0")}
                    </p>
                    <p className="capitalize text-sm text-gray-600 truncate">Yrs Experience</p>
                  </div>
                </div>
              </div>
            </section>
          </div>

          {/* Box 3 - User Details */}
          <div className="col-span-2 row-span-4 row-start-2 bg-white rounded-lg shadow">
            <List
              sx={{
                width: "100%",
                maxWidth: 420,
                bgcolor: "white",
                "& .MuiListSubheader-root": {
                  backgroundColor: "white",
                  color: "black",
                  fontWeight: "600",
                  fontSize: "1rem",
                  lineHeight: "2.5rem",
                  borderBottom: "1px solid #e0e0e0",
                },
              }}
              component="nav"
              aria-labelledby="nested-list-subheader"
            >
              <ListSubheader component="div">Details</ListSubheader>
              <ListItemButton>
                <ListItemIcon>
                  <LocalPhoneOutlinedIcon sx={{ color: "#333" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Phone Number"
                  secondary={safe(driverData?.phone)}
                  sx={{
                    "& .MuiListItemText-secondary": {
                      color: "#333",
                    },
                  }}
                />
              </ListItemButton>
              <ListItemButton>
                <ListItemIcon>
                  <EmailOutlinedIcon sx={{ color: "#333" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Email Address"
                  secondary={safe(driverData?.email)}
                  sx={{
                    "& .MuiListItemText-secondary": {
                      color: "#333",
                    },
                  }}
                />
              </ListItemButton>
              <ListItemButton>
                <ListItemIcon>
                  <CardMembershipOutlinedIcon sx={{ color: "#333" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Status"
                  secondary={driverData?.Status === "1" ? "Active" : "Inactive"}
                  sx={{
                    "& .MuiListItemText-secondary": {
                      color: driverData?.Status === "1" ? "#22c55e" : "#ef4444",
                      fontWeight: "600"
                    },
                  }}
                />
              </ListItemButton>
              <ListItemButton>
                <ListItemIcon>
                  <EmailOutlinedIcon sx={{ color: "#333" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Verification Status"
                  secondary={driverData?.verified === "1" ? "Verified" : "Not Verified"}
                  sx={{
                    "& .MuiListItemText-secondary": {
                      color: driverData?.verified === "1" ? "#22c55e" : "#ef4444",
                      fontWeight: "600"
                    },
                  }}
                />
              </ListItemButton>
              <ListItemButton>
                <ListItemIcon>
                  <SpeedIcon sx={{ color: "#333" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Experience"
                  secondary={`${safe(driverData?.drive_data?.experience, "0")} years`}
                  sx={{
                    "& .MuiListItemText-secondary": {
                      color: "#333",
                    },
                  }}
                />
              </ListItemButton>
              <ListItemButton>
                <ListItemIcon>
                  <StarIcon sx={{ color: "#333" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Gender"
                  secondary={driverData?.gender === "1" ? "Male" : driverData?.gender === "2" ? "Female" : "Other"}
                  sx={{
                    "& .MuiListItemText-secondary": {
                      color: "#333",
                    },
                  }}
                />
              </ListItemButton>
              <ListSubheader component="div">Documents</ListSubheader>
              <ListItemButton
                onClick={() => handleDocumentClick("Aadhar Card Front")}
              >
                <ListItemIcon>
                  <AssuredWorkloadIcon sx={{ color: "#333" }} />
                </ListItemIcon>
                <ListItemText primary="Aadhar Card Front" />
              </ListItemButton>
              <ListItemButton
                onClick={() => handleDocumentClick("Aadhar Card Back")}
              >
                <ListItemIcon>
                  <AssuredWorkloadIcon sx={{ color: "#333" }} />
                </ListItemIcon>
                <ListItemText primary="Aadhar Card Back" />
              </ListItemButton>
              <ListItemButton
                onClick={() => handleDocumentClick("Driving License Front")}
              >
                <ListItemIcon>
                  <LocalShippingIcon sx={{ color: "#333" }} />
                </ListItemIcon>
                <ListItemText primary="Driving License Front" />
              </ListItemButton>
              <ListItemButton
                onClick={() => handleDocumentClick("Driving License Back")}
              >
                <ListItemIcon>
                  <LocalShippingIcon sx={{ color: "#333" }} />
                </ListItemIcon>
                <ListItemText primary="Driving License Back" />
              </ListItemButton>
              <ListItemButton
                onClick={() => handleDocumentClick("Character Certificate")}
                >
                  <ListItemIcon>
                    <SensorOccupiedIcon sx={{ color: "#333" }} />
                  </ListItemIcon>
                  <ListItemText primary="Character Certificate" />
                </ListItemButton>
              <div className="flex flex-col space-y-4 justify-center mt-6 mb-4 px-4">
                {driverData?.verified === "1" ? (
                  <button className="w-full py-2 bg-green-600 text-white rounded-md cursor-default flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    Driver Verified ✓
                  </button>
                ) : (
                  <button className="w-full py-2 bg-orange-600 text-white rounded-md hover:bg-orange-700 flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 16.5c-.77.833.192 2.5 1.732 2.5z"
                      />
                    </svg>
                    Verify Driver
                  </button>
                )}
                <div className="flex justify-center space-x-4">
                  <button
                    onClick={handleEditClick}
                    className="px-4 py-2 bg-teal-600 text-white rounded-md hover:bg-teal-700 flex-1"
                  >
                    Edit
                  </button>
                  <button className={`px-4 py-2 text-white rounded-md flex-1 ${
                    driverData?.Status === "1" 
                      ? "bg-red-500 hover:bg-red-600" 
                      : "bg-green-500 hover:bg-green-600"
                  }`}>
                    {driverData?.Status === "1" ? "Suspend" : "Activate"}
                  </button>
                </div>
              </div>
            </List>
          </div>

          {/* Box 4 - Performance Overview */}
          <div className="col-span-2 row-span-2 col-start-3 row-start-2 bg-white p-4 rounded-lg shadow">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold text-gray-800">
                Performance Overview
              </h3>
              <MoreHorizIcon className="text-gray-500 cursor-pointer" />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="flex items-center p-3 rounded-lg bg-blue-50">
                <StarIcon className="h-8 w-8 text-blue-500 mr-3" />
                <div>
                  <p className="text-2xl font-semibold">
                    {safe(driverData?.drive_data?.rating, "0")}
                  </p>
                  <p className="text-sm text-gray-600">Rating</p>
                </div>
              </div>

              <div className="flex items-center p-3 rounded-lg bg-green-50">
                <SpeedIcon className="h-8 w-8 text-green-500 mr-3" />
                <div>
                  <p className="text-2xl font-semibold">
                    {safe(driverData?.drive_data?.experience, "0")}
                  </p>
                  <p className="text-sm text-gray-600">Years Experience</p>
                </div>
              </div>

              <div className="flex items-center p-3 rounded-lg bg-yellow-50">
                <DirectionsCarIcon className="h-8 w-8 text-yellow-500 mr-3" />
                <div>
                  <p className="text-2xl font-semibold">
                    {safe(driverData?.convoy_join_model?.length, "0")}
                  </p>
                  <p className="text-sm text-gray-600">Convoys Joined</p>
                </div>
              </div>

              <div className="flex items-center p-3 rounded-lg bg-purple-50">
                <AccessTimeIcon className="h-8 w-8 text-purple-500 mr-3" />
                <div>
                  <p className="text-2xl font-semibold">
                    {safe(driverData?.saved_jobs?.length, "0")}
                  </p>
                  <p className="text-sm text-gray-600">Saved Jobs</p>
                </div>
              </div>
            </div>

            <div className="mt-3 pt-3 border-t border-gray-200">
              <div className="flex justify-between items-center">
                <p className="text-sm text-gray-600">
                  Account Created: {(() => {
                    const d = new Date(driverData?.created_at);
                    if (isNaN(d)) return "N/A";
                    const dd = String(d.getDate()).padStart(2, "0");
                    const mm = String(d.getMonth() + 1).padStart(2, "0");
                    return `${dd}-${mm}-${d.getFullYear()}`;
                  })()}
                </p>
                <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
                  driverData?.verified === "1" 
                    ? "bg-green-100 text-green-800" 
                    : "bg-orange-100 text-orange-800"
                }`}>
                  {driverData?.verified === "1" ? "✓ Verified" : "⚠ Pending Verification"}
                </span>
              </div>
            </div>
          </div>

          {/* Box 5 - Driver Location */}
          <div className="col-span-2 row-span-2 col-start-3 row-start-4 bg-white p-3 rounded-lg shadow">
            <div className="border-b pb-2 mb-2">
              <h3 className="text-lg font-medium text-gray-800 flex items-center">
                <LocationOnIcon className="h-5 w-5 mr-2 text-teal-600" />
                Driver Location
              </h3>
            </div>
            <div ref={dashboardMapRef} className="h-[350px] w-full rounded" />
          </div>

          {/* Box 6 - User Activity Timeline */}
          <div className="col-span-2 row-span-4 col-start-5 row-start-2 bg-white p-4 rounded-lg shadow">
            <h3 className="text-lg font-semibold text-gray-800 border-b pb-2 mb-4">
              Recent Activity ({driverData?.time_lines?.length || 0})
            </h3>

            <div className="overflow-y-auto max-h-[750px] pr-2">
              <div className="space-y-4">
                {/* Timeline Items */}
                {driverData?.time_lines && driverData.time_lines.length > 0 ? (
                  driverData.time_lines.slice(0, 10).map((item, index) => (
                    <div className="flex" key={item.id}>
                      <div className="flex flex-col items-center mr-4">
                        <div className={`w-3 h-3 ${
                          item.title.includes("Splash") || item.title.includes("MainActivity") ? "bg-green-500" :
                          item.title.includes("Error") ? "bg-red-500" :
                          item.title.includes("Job") ? "bg-blue-600" :
                          "bg-purple-500"} rounded-full`}></div>
                        {index < Math.min(driverData.time_lines.length - 1, 9) && (
                          <div className="w-0.5 h-full bg-gray-200 mt-1"></div>
                        )}
                      </div>
                      <div className="bg-gray-50 p-3 rounded-lg shadow-sm flex-1 mb-2">
                        <span className="text-xs font-medium text-gray-500 block mb-1">
                          {formatTimelineDate(item.created_at)}
                        </span>
                        <p className="text-sm font-medium text-gray-800">
                          {item.title}
                        </p>
                        <p className="text-xs text-gray-600 mt-1">
                          {item.description}
                        </p>
                        {item.lat && item.lon && (
                          <p className="text-xs text-blue-600 mt-1">
                            📍 Location: {parseFloat(item.lat).toFixed(4)}, {parseFloat(item.lon).toFixed(4)}
                          </p>
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="flex justify-center items-center h-40">
                    <div className="text-center">
                      <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                      </svg>
                      <p className="text-gray-500 mt-2">No activity records found</p>
                      <p className="text-xs text-gray-400 mt-1">Activity will appear here when the driver uses the app</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Box 7 - Activity Chart */}
          <div className="col-span-3 row-span-3 row-start-6 bg-white p-4 rounded-lg shadow">
            <h3 className="text-lg font-medium text-gray-800 mb-4">
              App Usage Activity (Last 7 Days)
            </h3>
            <LineChart
              height={350}
              series={[
                {
                  data: [
                    driverData?.time_lines?.filter(item => 
                      new Date(item.created_at).toDateString() === new Date(Date.now() - 6*24*60*60*1000).toDateString()
                    ).length || 5,
                    driverData?.time_lines?.filter(item => 
                      new Date(item.created_at).toDateString() === new Date(Date.now() - 5*24*60*60*1000).toDateString()
                    ).length || 3,
                    driverData?.time_lines?.filter(item => 
                      new Date(item.created_at).toDateString() === new Date(Date.now() - 4*24*60*60*1000).toDateString()
                    ).length || 8,
                    driverData?.time_lines?.filter(item => 
                      new Date(item.created_at).toDateString() === new Date(Date.now() - 3*24*60*60*1000).toDateString()
                    ).length || 12,
                    driverData?.time_lines?.filter(item => 
                      new Date(item.created_at).toDateString() === new Date(Date.now() - 2*24*60*60*1000).toDateString()
                    ).length || 6,
                    driverData?.time_lines?.filter(item => 
                      new Date(item.created_at).toDateString() === new Date(Date.now() - 1*24*60*60*1000).toDateString()
                    ).length || 15,
                    driverData?.time_lines?.filter(item => 
                      new Date(item.created_at).toDateString() === new Date().toDateString()
                    ).length || 9
                  ],
                  label: "App Activities",
                  color: "#2563eb",
                  curve: "natural",
                  showMark: true,
                },
              ]}
              xAxis={[
                {
                  data: ["6d ago", "5d ago", "4d ago", "3d ago", "2d ago", "Yesterday", "Today"],
                  scaleType: "point",
                  tickLabelStyle: {
                    angle: 0,
                    textAnchor: "middle",
                    fill: "#333333",
                  },
                },
              ]}
              yAxis={[
                {
                  label: "Activities Count",
                  tickLabelStyle: {
                    fill: "#333333",
                  },
                  labelStyle: {
                    fill: "#333333",
                  },
                },
              ]}
              grid={{
                vertical: true,
                horizontal: true,
                verticalLineDasharray: "none",
                horizontalLineDasharray: "none",
                verticalLineColor: "#333333",
                horizontalLineColor: "#333333",
              }}
              slotProps={{
                legend: {
                  direction: "row",
                  position: { vertical: "bottom", horizontal: "middle" },
                  padding: 10,
                  itemMarkWidth: 10,
                  itemMarkHeight: 10,
                  labelStyle: {
                    fill: "#333333",
                  },
                },
              }}
              margin={{ left: 70, right: 20, top: 20, bottom: 60 }}
              sx={{
                ".MuiLineElement-root": {
                  strokeWidth: 2,
                },
                ".MuiMarkElement-root": {
                  stroke: "#2563eb",
                  scale: "0.6",
                  fill: "white",
                  strokeWidth: 2,
                },
                ".MuiChartsAxis-label": {
                  fill: "#333333",
                },
                ".MuiChartsAxis-tick": {
                  stroke: "#333333",
                },
                ".MuiChartsAxis-line": {
                  stroke: "#333333",
                },
                ".MuiChartsGrid-line": {
                  stroke: "#333333",
                  strokeWidth: 0.5,
                },
              }}
            />
          </div>

          {/* Box 8 - Account Overview */}
          <div className="col-span-3 row-span-3 col-start-4 row-start-6 bg-white p-4 rounded-lg shadow">
            <h3 className="text-lg font-medium text-gray-800 mb-4">
              Account Statistics Overview
            </h3>
            <BarChart
              series={[
                { 
                  data: [
                    driverData?.job_applications?.length || 0,
                    driverData?.convoy_model?.length || 0,
                    driverData?.convoy_join_model?.length || 0,
                    driverData?.saved_jobs?.length || 0
                  ], 
                  label: "Driver Stats", 
                  color: "#4f46e5" 
                },
              ]}
              height={350}
              xAxis={[
                {
                  data: ["Job Applications", "Convoys Created", "Convoys Joined", "Saved Jobs"],
                  scaleType: "band",
                  tickLabelStyle: {
                    angle: -45,
                    textAnchor: "end",
                    fill: "#333333",
                  },
                },
              ]}
              yAxis={[
                {
                  label: "Count",
                  tickLabelStyle: {
                    fill: "#333333",
                  },
                  labelStyle: {
                    fill: "#333333",
                  },
                },
              ]}
              grid={{
                vertical: true,
                horizontal: true,
                verticalLineDasharray: "none",
                horizontalLineDasharray: "none",
                verticalLineColor: "#333333",
                horizontalLineColor: "#333333",
              }}
              slotProps={{
                legend: {
                  direction: "row",
                  position: { vertical: "bottom", horizontal: "middle" },
                  padding: 10,
                  labelStyle: {
                    fill: "#333333",
                  },
                },
              }}
              margin={{ left: 70, right: 20, top: 20, bottom: 80 }}
              legend={{ hidden: false }}
              sx={{
                ".MuiChartsAxis-label": {
                  fill: "#333333",
                },
                ".MuiChartsAxis-tick": {
                  stroke: "#333333",
                },
                ".MuiChartsAxis-line": {
                  stroke: "#333333",
                },
                ".MuiChartsGrid-line": {
                  stroke: "#333333",
                  strokeWidth: 0.5,
                },
              }}
            />
          </div>
        </div>
          </>
        ) : activeTab === 'locations' ? (
          /* Locations Tab Content */
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 h-[calc(100vh-150px)]">
            {/* Map Section - Takes up 2/3 of the space */}
            <div className="lg:col-span-2 bg-white rounded-lg shadow overflow-hidden">
              <div className="p-4 border-b bg-gray-50">
                <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
                  <h3 className="text-lg font-semibold text-gray-800 flex items-center">
                    <LocationOnIcon className="h-5 w-5 mr-2 text-teal-600" />
                    Location History Map
                  </h3>

                  {/* Date Filter Controls */}
                  <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center">
                    <div className="flex flex-col sm:flex-row gap-2">
                      {/* Single Date Filter */}
                      <div className="flex items-center gap-2">
                        <label className="text-sm font-medium text-gray-700 whitespace-nowrap">Date:</label>
                        <input
                          type="date"
                          value={filterDate}
                          onChange={(e) => {
                            setFilterDate(e.target.value);
                            if (e.target.value) {
                              setFilterFromDate('');
                              setFilterToDate('');
                            }
                          }}
                          className="px-3 py-1.5 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                        />
                      </div>

                      {/* Date Range Filter */}
                      <div className="flex items-center gap-2">
                        <label className="text-sm font-medium text-gray-700 whitespace-nowrap">From:</label>
                        <input
                          type="date"
                          value={filterFromDate}
                          onChange={(e) => {
                            setFilterFromDate(e.target.value);
                            if (e.target.value) {
                              setFilterDate('');
                            }
                          }}
                          disabled={!!filterDate}
                          className="px-3 py-1.5 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                        />
                      </div>

                      <div className="flex items-center gap-2">
                        <label className="text-sm font-medium text-gray-700 whitespace-nowrap">To:</label>
                        <input
                          type="date"
                          value={filterToDate}
                          onChange={(e) => {
                            setFilterToDate(e.target.value);
                            if (e.target.value) {
                              setFilterDate('');
                            }
                          }}
                          disabled={!!filterDate}
                          className="px-3 py-1.5 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                        />
                      </div>
                    </div>

                    {/* Filter Buttons */}
                    <div className="flex gap-2">
                      <button
                        onClick={handleApplyFilter}
                        disabled={(!filterDate && (!filterFromDate || !filterToDate)) || locationsLoading}
                        className="px-4 py-1.5 bg-teal-600 text-white text-sm font-medium rounded-md hover:bg-teal-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
                      >
                        Apply Filter
                      </button>
                      <button
                        onClick={handleClearFilter}
                        disabled={!filterDate && !filterFromDate && !filterToDate}
                        className="px-4 py-1.5 bg-gray-200 text-gray-700 text-sm font-medium rounded-md hover:bg-gray-300 disabled:bg-gray-100 disabled:cursor-not-allowed transition-colors"
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>

                {/* Selected Location Info */}
                {selectedLocation && (
                  <div className="mt-3 pt-3 border-t border-gray-200">
                    <div className="text-sm text-gray-600">
                      <span className="font-medium">Selected:</span> {formatToLocalTime(selectedLocation.created_at)}
                    </div>
                  </div>
                )}

                {/* Active Filter Info */}
                {applyFilter && (filterDate || (filterFromDate && filterToDate)) && (
                  <div className="mt-2 pt-2 border-t border-gray-200">
                    <div className="text-xs text-gray-600 flex items-center gap-2">
                      <span className="font-medium">Active Filter:</span>
                      {filterDate && (
                        <span className="bg-teal-100 text-teal-800 px-2 py-1 rounded-full">
                          Date: {filterDate}
                        </span>
                      )}
                      {filterFromDate && filterToDate && (
                        <span className="bg-teal-100 text-teal-800 px-2 py-1 rounded-full">
                          {filterFromDate} to {filterToDate}
                        </span>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div
                ref={locationsMapRef}
                className="h-[calc(100%-60px)] w-full"
                style={{ minHeight: '500px' }}
              />
            </div>

            {/* Logs Section - Takes up 1/3 of the space */}
            <div className="lg:col-span-1 bg-white rounded-lg shadow overflow-hidden flex flex-col">
              <div className="p-4 border-b bg-gray-50">
                <h3 className="text-lg font-semibold text-gray-800">
                  Location Logs ({locations.length})
                </h3>
                {applyFilter && (filterDate || (filterFromDate && filterToDate)) && (
                  <div className="mt-2 text-xs text-gray-600">
                    <span className="font-medium">Filter: </span>
                    {filterDate ? (
                      <span className="bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full">
                        {filterDate}
                      </span>
                    ) : (
                      <span className="bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full">
                        {filterFromDate} - {filterToDate}
                      </span>
                    )}
                  </div>
                )}
              </div>

              <div
                className="flex-1 overflow-auto"
                onScroll={handleTableScroll}
              >
                {locationsLoading && locations.length === 0 ? (
                  <div className="flex items-center justify-center h-40">
                    <CircularProgress />
                  </div>
                ) : locations.length === 0 ? (
                  <div className="flex items-center justify-center h-40 text-gray-500">
                    No location data available
                  </div>
                ) : (
                  <>
                    <TableContainer component={Paper} elevation={0}>
                      <Table size="small" stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              sx={{ fontWeight: 'bold', backgroundColor: '#f9fafb' }}
                            >
                              Time
                            </TableCell>
                            <TableCell
                              sx={{ fontWeight: 'bold', backgroundColor: '#f9fafb' }}
                            >
                              Coordinates
                            </TableCell>
                            <TableCell
                              sx={{ fontWeight: 'bold', backgroundColor: '#f9fafb' }}
                            >
                              Address
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {locations.map((loc, index) => (
                            <TableRow
                              key={loc.id}
                              hover
                              selected={selectedLocation?.id === loc.id}
                              onClick={() => handleLocationClick(loc)}
                              sx={{
                                cursor: 'pointer',
                                '&:hover': {
                                  backgroundColor: '#f0f9ff',
                                },
                                '&.Mui-selected': {
                                  backgroundColor: '#e0f2fe',
                                },
                              }}
                            >
                              <TableCell>
                                <div className="text-xs">
                                  <div className="font-medium">
                                    {formatToLocalTime(loc.created_at).split(',')[0]}
                                  </div>
                                  <div className="text-gray-500">
                                    {formatToLocalTime(loc.created_at).split(',')[1] || ''}
                                  </div>
                                </div>
                              </TableCell>
                              <TableCell>
                                <div className="text-xs">
                                  <div>Lat: {parseFloat(loc.latitude).toFixed(4)}</div>
                                  <div>Lon: {parseFloat(loc.longitude).toFixed(4)}</div>
                                </div>
                              </TableCell>
                              <TableCell>
                                <Tooltip
                                  title={locationAddresses[loc.id] || 'Loading...'}
                                  placement="left"
                                >
                                  <div className="text-xs max-w-[150px] truncate">
                                    {locationAddresses[loc.id] || (
                                      <span className="text-gray-400">Loading...</span>
                                    )}
                                  </div>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>

                    {/* Load more indicator */}
                    {hasMore && (
                      <div className="p-4 text-center">
                        {loadingMore ? (
                          <CircularProgress size={24} />
                        ) : (
                          <div className="text-sm text-gray-500">
                            Scroll to load more locations...
                          </div>
                        )}
                      </div>
                    )}

                    {!hasMore && locations.length > 0 && (
                      <div className="p-4 text-center text-sm text-gray-500">
                        All locations loaded
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        ) : activeTab === 'finance' ? (
          /* Finance Tab Content */
          <div className="p-4 space-y-4">
            {/* Filters */}
            <div className="bg-white rounded-lg shadow p-4">
              <div className="flex flex-wrap items-end gap-3">
                <div className="flex flex-col gap-1">
                  <label className="text-sm font-medium text-gray-700">Status</label>
                  <select
                    value={salaryStatus}
                    onChange={(e) => setSalaryStatus(e.target.value)}
                    className="border border-gray-300 rounded px-3 py-2 text-sm text-gray-800"
                  >
                    <option value="">All</option>
                    <option value="0">Initiated</option>
                    <option value="1">Processed</option>
                    <option value="2">Transferred</option>
                  </select>
                </div>
                <div className="flex flex-col gap-1">
                  <label className="text-sm font-medium text-gray-700">Billing From</label>
                  <input
                    type="date"
                    value={salaryFrom}
                    onChange={(e) => setSalaryFrom(e.target.value)}
                    className="border border-gray-300 rounded px-3 py-2 text-sm text-gray-800"
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <label className="text-sm font-medium text-gray-700">Billing To</label>
                  <input
                    type="date"
                    value={salaryTo}
                    onChange={(e) => setSalaryTo(e.target.value)}
                    className="border border-gray-300 rounded px-3 py-2 text-sm text-gray-800"
                  />
                </div>
                <div className="flex items-center gap-2">
                  <button
                    onClick={applySalaryFilters}
                    className="bg-teal-600 text-white text-sm font-medium px-4 py-2 rounded hover:bg-teal-700"
                  >
                    Apply
                  </button>
                  <button
                    onClick={clearSalaryFilters}
                    className="bg-gray-200 text-gray-700 text-sm font-medium px-4 py-2 rounded hover:bg-gray-300"
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>

            {/* Table */}
            <div className="bg-white rounded-lg shadow overflow-hidden">
              {salaryLoading && !salaryRows.length ? (
                <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
                  <CircularProgress />
                </Box>
              ) : salaryRows.length === 0 ? (
                <Box sx={{ textAlign: "center", py: 8, color: "gray" }}>
                  <Typography variant="h6">No salary records found</Typography>
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    This driver has no billing records matching the current filters
                  </Typography>
                </Box>
              ) : (
                <TableContainer
                  component={Paper}
                  sx={{ backgroundColor: "#ffffff", color: "#000000", border: "1px solid #e5e7eb" }}
                >
                  <Table sx={{ minWidth: 1000, backgroundColor: "#ffffff", color: "#000000" }}>
                    <TableHead>
                      <TableRow sx={{ backgroundColor: "#f3f4f6" }}>
                        <TableCell sx={{ fontWeight: 600, color: "#111827" }}>Client</TableCell>
                        <TableCell sx={{ fontWeight: 600, color: "#111827" }}>Billing Dates</TableCell>
                        <TableCell sx={{ fontWeight: 600, color: "#111827" }}>Salary</TableCell>
                        <TableCell sx={{ fontWeight: 600, color: "#111827" }}>Status</TableCell>
                        <TableCell sx={{ fontWeight: 600, color: "#111827" }}>Deposit</TableCell>
                        <TableCell sx={{ fontWeight: 600, color: "#111827" }}>Net Salary</TableCell>
                        <TableCell sx={{ fontWeight: 600, color: "#111827" }}>Claims & Remarks</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {salaryRows.map((row) => {
                        const partiallyTransferred = parseFloat(row.deposit_amount || 0) > 0 && String(row.status) === "2";
                        const statusInfo = partiallyTransferred
                          ? { label: "Partially Transferred", color: "#E65100", bgColor: "#fbe9e7" }
                          : getSalaryStatusInfo(row.status);
                        const clientName = row.company_name || row.client_username || "N/A";
                        const clientImage = row.client_image ? `${config.apiImageUrl}${row.client_image}` : null;
                        const getInitials = (name) => {
                          if (!name) return "NA";
                          const words = String(name).trim().split(/\s+/);
                          if (words.length === 1) return words[0].substring(0, 2).toUpperCase();
                          return (words[0][0] + words[words.length - 1][0]).toUpperCase();
                        };
                        return (
                          <TableRow key={row.id} sx={{"&:hover": { backgroundColor: "#f9fafb" }}}>
                            <TableCell sx={{ color: "#000000" }}>
                              <div className="flex items-center gap-2">
                                <div
                                  className="flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center text-white text-xs font-bold"
                                  style={{ backgroundColor: "#2563eb" }}
                                >
                                  {clientImage ? (
                                    <img
                                      src={clientImage}
                                      alt={clientName}
                                      className="w-9 h-9 rounded-full object-cover"
                                      onError={(e) => {
                                        e.currentTarget.style.display = "none";
                                        e.currentTarget.nextElementSibling.style.display = "flex";
                                      }}
                                    />
                                  ) : (
                                    <span className="flex items-center justify-center w-full h-full">{getInitials(clientName)}</span>
                                  )}
                                  <span style={{ display: clientImage ? "none" : "flex" }}>
                                    {getInitials(clientName)}
                                  </span>
                                </div>
                                <div className="text-xs">
                                  <div className="font-medium text-gray-800">{clientName}</div>
                                  <div className="text-gray-500">{safe(row.client_id)}</div>
                                </div>
                              </div>
                            </TableCell>
                            <TableCell sx={{ color: "#000000" }}>
                              <div className="text-sm text-gray-800">
                                {String(row.from || "")
                                  .split("-")
                                  .reverse()
                                  .join("/") || "N/A"}{" "}
                                -{" "}
                                {String(row.till || "")
                                  .split("-")
                                  .reverse()
                                  .join("/") || "N/A"}
                              </div>
                            </TableCell>
                            <TableCell sx={{ color: "#000000" }}>
                              <div className="text-sm font-medium text-gray-800">
                                ₹{parseFloat(row.salary || 0).toFixed(2)}
                              </div>
                            </TableCell>
                            <TableCell sx={{ color: "#000000" }}>
                              <span
                                className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium"
                                style={{
                                  color: statusInfo.color,
                                  backgroundColor: statusInfo.bgColor,
                                }}
                              >
                                {statusInfo.label}
                              </span>
                            </TableCell>
                            <TableCell sx={{ color: "#000000" }}>
                              <div className="flex flex-col gap-1">
                                {parseFloat(row.deposit_amount || 0) > 0 ? (
                                  <>
                                    <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium w-fit"
                                      style={{ backgroundColor: "#fce4ec", color: "#c62828" }}>
                                      Hold ₹{parseFloat(row.deposit_amount).toFixed(2)} · {row.deposit_days || 0}d
                                    </span>
                                    {(() => {
                                      const depStatus = getDepositStatusInfo(row.deposit_status);
                                      return (
                                        <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium w-fit"
                                          style={{ color: depStatus.color, backgroundColor: depStatus.bgColor }}>
                                          {depStatus.label}
                                        </span>
                                      );
                                    })()}
                                  </>
                                ) : (
                                  <span className="text-xs text-gray-400">—</span>
                                )}
                              </div>
                            </TableCell>
                            <TableCell sx={{ color: "#000000" }}>
                              {(() => {
                                // Net = gross - claim (from note) - advance (from note) - deposit hold
                                let claimAmount = 0;
                                if (row.note && row.note.includes("Claim:")) {
                                  const claimMatch = row.note.match(/Claim:\s*([\d.]+)/i);
                                  if (claimMatch) claimAmount = parseFloat(claimMatch[1]) || 0;
                                }
                                let advanceAmount = 0;
                                if (row.note && row.note.includes("Advance:")) {
                                  const advanceMatch = row.note.match(/Advance:\s*([\d.]+)/i);
                                  if (advanceMatch) advanceAmount = parseFloat(advanceMatch[1]) || 0;
                                }
                                const depositAmount = parseFloat(row.deposit_amount || 0);
                                const net = parseFloat(row.salary || 0) - claimAmount - advanceAmount - depositAmount;
                                return (
                                  <div className="text-sm font-medium text-gray-800">
                                    ₹{net.toFixed(2)}
                                  </div>
                                );
                              })()}
                            </TableCell>
                            <TableCell sx={{ color: "#000000" }}>
                              <div className="text-xs text-gray-800 max-w-[250px]">
                                {row.note ? row.note : "N/A"}
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}

              {/* Pagination */}
              {salaryTotalPages > 1 && (
                <div className="flex items-center justify-between px-4 py-3 border-t border-gray-200">
                  <Typography variant="body2" color="text.secondary">
                    Page {salaryPage} of {salaryTotalPages}
                  </Typography>
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => handleSalaryPage(salaryPage - 1)}
                      disabled={salaryPage <= 1}
                      className="bg-gray-200 text-gray-700 text-sm font-medium px-4 py-1.5 rounded hover:bg-gray-300 disabled:opacity-50"
                    >
                      Prev
                    </button>
                    <button
                      onClick={() => handleSalaryPage(salaryPage + 1)}
                      disabled={salaryPage >= salaryTotalPages}
                      className="bg-gray-200 text-gray-700 text-sm font-medium px-4 py-1.5 rounded hover:bg-gray-300 disabled:opacity-50"
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          /* Job History Tab Content */
          <div className="p-4 space-y-4">
            {/* Filters */}
            <div className="bg-white rounded-lg shadow p-4">
              <div className="flex flex-wrap items-end gap-3">
                <div className="flex flex-col gap-1">
                  <label className="text-sm font-medium text-gray-700">Status</label>
                  <select
                    value={jobHistoryStatus}
                    onChange={(e) => setJobHistoryStatus(e.target.value)}
                    className="border border-gray-300 rounded px-3 py-2 text-sm text-gray-800"
                  >
                    <option value="">All</option>
                    <option value="1">Pending</option>
                    <option value="2">Accepted</option>
                    <option value="0">Rejected</option>
                  </select>
                </div>
                <div className="flex flex-col gap-1">
                  <label className="text-sm font-medium text-gray-700">Applied From</label>
                  <input
                    type="date"
                    value={jobHistoryFrom}
                    onChange={(e) => setJobHistoryFrom(e.target.value)}
                    className="border border-gray-300 rounded px-3 py-2 text-sm text-gray-800"
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <label className="text-sm font-medium text-gray-700">Applied To</label>
                  <input
                    type="date"
                    value={jobHistoryTo}
                    onChange={(e) => setJobHistoryTo(e.target.value)}
                    className="border border-gray-300 rounded px-3 py-2 text-sm text-gray-800"
                  />
                </div>
                <div className="flex flex-col gap-1 flex-1 min-w-[200px]">
                  <label className="text-sm font-medium text-gray-700">Search</label>
                  <input
                    type="text"
                    placeholder="Location, client, or vehicle..."
                    value={jobHistorySearch}
                    onChange={(e) => setJobHistorySearch(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") applyJobHistoryFilters();
                    }}
                    className="border border-gray-300 rounded px-3 py-2 text-sm text-gray-800"
                  />
                </div>
                <div className="flex items-center gap-2">
                  <button
                    onClick={applyJobHistoryFilters}
                    className="bg-teal-600 text-white text-sm font-medium px-4 py-2 rounded hover:bg-teal-700"
                  >
                    Apply
                  </button>
                  <button
                    onClick={clearJobHistoryFilters}
                    className="bg-gray-200 text-gray-700 text-sm font-medium px-4 py-2 rounded hover:bg-gray-300"
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>

            {/* Table */}
            <div className="bg-white rounded-lg shadow overflow-hidden">
              {jobHistoryLoading ? (
                <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
                  <CircularProgress />
                </Box>
              ) : jobHistory.length === 0 ? (
                <Box sx={{ textAlign: "center", py: 8, color: "gray" }}>
                  <Typography variant="h6">No job applications found</Typography>
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    This driver has not applied to any jobs matching the current filters
                  </Typography>
                </Box>
              ) : (
                <TableContainer
                  component={Paper}
                  sx={{ backgroundColor: "#ffffff", color: "#000000", border: "1px solid #e5e7eb" }}
                >
                  <Table sx={{ minWidth: 1000, backgroundColor: "#ffffff", color: "#000000" }}>
                    <TableHead>
                      <TableRow sx={{ backgroundColor: "#f3f4f6" }}>
                        <TableCell sx={{ fontWeight: 600, color: "#111827" }}>Job Locations</TableCell>
                        <TableCell sx={{ fontWeight: 600, color: "#111827" }}>Job Posted On</TableCell>
                        <TableCell sx={{ fontWeight: 600, color: "#111827" }}>Vehicle</TableCell>
                        <TableCell sx={{ fontWeight: 600, color: "#111827" }}>Client</TableCell>
                        <TableCell sx={{ fontWeight: 600, color: "#111827" }}>Applied On</TableCell>
                        <TableCell sx={{ fontWeight: 600, color: "#111827" }}>Status</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {jobHistory.map((item) => {
                        const job = item.job || {};
                        const client = job.client || {};
                        const vehicle = job.vehicle || {};
                        const statusInfo = getJobHistoryStatusInfo(item.application_status);
                        const clientImage = client.image ? `${config.apiImageUrl}${client.image}` : null;
                        const getInitials = (name) => {
                          if (!name) return "NA";
                          const words = String(name).trim().split(/\s+/);
                          if (words.length === 1) return words[0].substring(0, 2).toUpperCase();
                          return (words[0][0] + words[words.length - 1][0]).toUpperCase();
                        };
                        return (
                          <TableRow
                            key={item.id}
                            sx={{
                              backgroundColor: "#ffffff",
                              color: "#000000",
                              "&:hover": { backgroundColor: "#f9fafb" },
                            }}
                          >
                            <TableCell sx={{ color: "#000000" }}>
                              <div className="text-xs">
                                <div className="font-medium text-gray-800">
                                  From: {safe(job.StartLocation)}
                                </div>
                                <div className="font-medium text-gray-800">
                                  To: {safe(job.EndLocation)}
                                </div>
                              </div>
                            </TableCell>
                            <TableCell sx={{ color: "#000000" }}>
                              <div className="text-xs text-gray-800">
                                {formatJobDate(job.created_at)}
                              </div>
                            </TableCell>
                            <TableCell sx={{ color: "#000000" }}>
                              <div className="text-xs text-gray-800">
                                {vehicle.brand || vehicle.model || vehicle.wheels
                                  ? `${vehicle.brand || ""} / ${vehicle.wheels ? `${vehicle.wheels} wheeler` : ""} / ${vehicle.model || ""}`
                                  : "N/A"}
                              </div>
                            </TableCell>
                            <TableCell sx={{ color: "#000000" }}>
                              <div className="flex items-center gap-2">
                                <div
                                  className="flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center text-white text-xs font-bold"
                                  style={{ backgroundColor: "#2563eb" }}
                                >
                                  {clientImage ? (
                                    <img
                                      src={clientImage}
                                      alt={client.username || "client"}
                                      className="w-9 h-9 rounded-full object-cover"
                                      onError={(e) => {
                                        e.currentTarget.style.display = "none";
                                        e.currentTarget.nextElementSibling.style.display = "flex";
                                      }}
                                    />
                                  ) : (
                                    <span>{getInitials(client.username)}</span>
                                  )}
                                  <span style={{ display: clientImage ? "none" : "flex" }}>
                                    {getInitials(client.username)}
                                  </span>
                                </div>
                                <div className="text-xs">
                                  <div className="font-medium text-gray-800">{safe(client.username)}</div>
                                  <div className="text-gray-500">{safe(client.phone)}</div>
                                </div>
                              </div>
                            </TableCell>
                            <TableCell sx={{ color: "#000000" }}>
                              <div className="text-xs text-gray-800">
                                {formatJobDate(item.applied_at)}
                              </div>
                            </TableCell>
                            <TableCell sx={{ color: "#000000" }}>
                              <span
                                className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium"
                                style={{
                                  color: statusInfo.color,
                                  backgroundColor: statusInfo.bgColor,
                                }}
                              >
                                {statusInfo.label}
                              </span>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}

              {/* Pagination */}
              {jobHistoryTotalPages > 1 && (
                <div className="flex items-center justify-between px-4 py-3 border-t border-gray-200">
                  <Typography variant="body2" color="text.secondary">
                    Page {jobHistoryPage} of {jobHistoryTotalPages}
                  </Typography>
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => handleJobHistoryPage(jobHistoryPage - 1)}
                      disabled={jobHistoryPage <= 1}
                      className="bg-gray-200 text-gray-700 text-sm font-medium px-4 py-1.5 rounded hover:bg-gray-300 disabled:opacity-50"
                    >
                      Prev
                    </button>
                    <button
                      onClick={() => handleJobHistoryPage(jobHistoryPage + 1)}
                      disabled={jobHistoryPage >= jobHistoryTotalPages}
                      className="bg-gray-200 text-gray-700 text-sm font-medium px-4 py-1.5 rounded hover:bg-gray-300 disabled:opacity-50"
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        <Modal
          open={imageModalOpen}
          onClose={() => setImageModalOpen(false)}
          aria-labelledby="document-modal-title"
          aria-describedby="document-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "auto",
              maxWidth: "80%",
              maxHeight: "80%",
              bgcolor: "background.paper",
              boxShadow: 24,
              borderRadius: 2,
              p: 3,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography
                id="document-modal-title"
                variant="h6"
                component="h2"
                sx={{ fontFamily: "Ubuntu, sans-serif" }}
              >
                {currentDocName}
              </Typography>
              <IconButton onClick={() => setImageModalOpen(false)} size="small">
                <CloseIcon />
              </IconButton>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: 300,
                minWidth: 400,
              }}
            >
              <img
                src={currentImage}
                alt={`${currentDocName} document`}
                style={{
                  maxWidth: "100%",
                  maxHeight: "60vh",
                  objectFit: "contain",
                }}
              />
            </Box>
          </Box>
        </Modal>
        <EditDriver
          open={editDriverOpen}
          handleClose={() => setEditDriverOpen(false)}
          driverData={driverData}
          onDriverUpdated={handleDriverUpdated}
        />
      </div>
      )}
    </>
  );
}

export default DriverView;
